(function () {
  const faqSections = document.querySelectorAll('[data-fm-faq]');

  faqSections.forEach((section) => {
    const items = section.querySelectorAll('details');

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.removeAttribute('open');
          }
        });
      });
    });
  });
})();

/* ==========================================================================
   Frescomarché - Cart quick actions
   ========================================================================== */

(function () {
  function currencyCode() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var hasDecimals = Math.round(amount) !== amount;

    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: currencyCode(),
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0
      }).format(amount).replace(/\s/g, ' ');
    } catch (error) {
      return amount.toFixed(hasDecimals ? 2 : 0).replace('.', ',') + ' €';
    }
  }

  var confirmedHeaderCart = null;
  var optimisticHeaderLocks = 0;

  function renderHeaderCart(cartData) {
    if (!cartData) return;

    document.querySelectorAll('[data-fm-cart-total]').forEach(function (item) {
      /* Le panier affiche le prix des produits AVANT remise : les codes
         promo s'appliquent au paiement, pas dans l'en-tete. */
      var brut = cartData.original_total_price;
      if (brut === undefined || brut === null) brut = cartData.total_price;
      item.textContent = formatMoney(brut);
      item.dataset.fmCartTotalCents = String(Math.max(Number(brut) || 0, 0));
    });

    document.querySelectorAll('[data-fm-cart-count]').forEach(function (item) {
      var count = Number(cartData.item_count) || 0;
      item.textContent = String(count);
      item.hidden = count === 0;
      item.dataset.fmCartItemCount = String(count);
    });
  }

  function updateHeaderCart(cartData) {
    if (!cartData) return;

    var brutTotal = cartData.original_total_price;
    if (brutTotal === undefined || brutTotal === null) brutTotal = cartData.total_price;
    confirmedHeaderCart = {
      total_price: Math.max(Number(brutTotal) || 0, 0),
      item_count: Math.max(Number(cartData.item_count) || 0, 0)
    };

    if (optimisticHeaderLocks > 0) return;
    renderHeaderCart(confirmedHeaderCart);
  }

  function beginOptimisticHeaderUpdate(totalDelta, itemDelta) {
    var totalElement = document.querySelector('[data-fm-cart-total]');
    var countElement = document.querySelector('[data-fm-cart-count]');
    var currentTotal = totalElement
      ? Number(totalElement.dataset.fmCartTotalCents)
      : NaN;
    var currentCount = countElement
      ? Number(countElement.dataset.fmCartItemCount)
      : NaN;

    if (!Number.isFinite(currentTotal)) {
      currentTotal = confirmedHeaderCart ? confirmedHeaderCart.total_price : 0;
    }
    if (!Number.isFinite(currentCount)) {
      currentCount = confirmedHeaderCart ? confirmedHeaderCart.item_count : 0;
    }

    optimisticHeaderLocks += 1;
    renderHeaderCart({
      total_price: Math.max(currentTotal + (Number(totalDelta) || 0), 0),
      item_count: Math.max(currentCount + (Number(itemDelta) || 0), 0)
    });
  }

  function settleOptimisticHeaderUpdate() {
    optimisticHeaderLocks = Math.max(optimisticHeaderLocks - 1, 0);
    if (optimisticHeaderLocks === 0 && confirmedHeaderCart) {
      renderHeaderCart(confirmedHeaderCart);
    }
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      return response.json();
    });
  }

  function renderCartSections(parsedState, openDrawer) {
    var cart = document.querySelector('cart-drawer');
    if (!cart || !parsedState || !parsedState.sections || typeof cart.getSectionsToRender !== 'function') return;

    cart.getSectionsToRender().forEach(function (section) {
      var sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections[section.id]) return;

      sectionElement.innerHTML = cart.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    var cartIsEmpty = Number(parsedState.item_count) === 0;
    cart.classList.toggle('is-empty', cartIsEmpty);

    var inner = cart.querySelector('.drawer__inner');
    if (inner) inner.classList.toggle('is-empty', cartIsEmpty);

    var overlay = cart.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof cart.close === 'function') {
      overlay.addEventListener('click', cart.close.bind(cart));
    }

    if (openDrawer && typeof cart.open === 'function') {
      window.setTimeout(function () {
        cart.open();
      }, 20);
    }
  }

  function sectionIds(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return [];

    return cart.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  function addVariant(variantId, options) {
    var opts = options || {};
    var cart = document.querySelector('cart-drawer');
    var formData = new FormData();
    var config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/json' } };

    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    formData.append('id', variantId);
    formData.append('quantity', String(opts.quantity || 1));
    var productCard = opts.button && opts.button.closest
      ? opts.button.closest('[data-fm-product-family]')
      : null;
    var productFamily = productCard ? productCard.getAttribute('data-fm-product-family') : '';
    if (productFamily) {
      formData.append('properties[_Famille]', productFamily);
    }

    if (cart) {
      formData.append('sections', sectionIds(cart).join(','));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(opts.button || document.activeElement);
      }
    }

    config.body = formData;

    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Impossible d’ajouter ce produit.');
        }

        renderCartSections(response, opts.openDrawer);
        return fetchCart();
      })
      .then(function (cartData) {
        updateHeaderCart(cartData);
        if (typeof window.FMSyncCheckoutDeliverySlot === 'function') {
          window.FMSyncCheckoutDeliverySlot();
        }
        var addedItem = cartData && Array.isArray(cartData.items)
          ? cartData.items.find(function (item) {
            return String(item.variant_id) === String(variantId);
          })
          : null;
        document.dispatchEvent(new CustomEvent('fm:cart:added', {
          detail: { item: addedItem, quantity: opts.quantity || 1 }
        }));
        return cartData;
      });
  }

  function setVariantQuantity(variantId, quantity, options) {
    var opts = options || {};
    var nextQuantity = Math.max(Number(quantity) || 0, 0);
    var cartDrawer = document.querySelector('cart-drawer');

    return fetchCart()
      .then(function (cartData) {
        var line = cartData && Array.isArray(cartData.items)
          ? cartData.items.find(function (item) {
            return String(item.variant_id) === String(variantId);
          })
          : null;

        if (!line && nextQuantity > 0) {
          return addVariant(variantId, {
            button: opts.button,
            quantity: nextQuantity,
            openDrawer: opts.openDrawer
          });
        }

        if (!line) return cartData;

        var formData = new FormData();
        var config = typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/json' } };

        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        formData.append('id', line.key);
        formData.append('quantity', String(nextQuantity));

        if (cartDrawer) {
          formData.append('sections', sectionIds(cartDrawer).join(','));
          formData.append('sections_url', window.location.pathname);
          if (typeof cartDrawer.setActiveElement === 'function') {
            cartDrawer.setActiveElement(opts.button || document.activeElement);
          }
        }

        config.body = formData;

        return fetch((window.routes && window.routes.cart_change_url) || '/cart/change', config)
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              throw new Error(response.description || response.message || 'Impossible de modifier ce produit.');
            }

            renderCartSections(response, opts.openDrawer);
            return fetchCart();
          })
          .then(function (updatedCart) {
            updateHeaderCart(updatedCart);
            return updatedCart;
          });
      });
  }

  function clearCart(options) {
    var opts = options || {};
    var cartDrawer = document.querySelector('cart-drawer');
    var formData = new FormData();
    var config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/json' } };

    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    if (cartDrawer) {
      formData.append('sections', sectionIds(cartDrawer).join(','));
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    return fetch((window.routes && window.routes.cart_clear_url) || '/cart/clear.js', config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Impossible de vider le panier.');
        }
        renderCartSections(response, opts.openDrawer);
        return fetchCart();
      })
      .then(function (cartData) {
        updateHeaderCart(cartData);
        return cartData;
      });
  }

  function openCart(trigger) {
    var cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.open !== 'function') {
      console.warn('Frescomarche: tiroir panier introuvable.');
      return;
    }

    if (typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(trigger || document.activeElement);
    }

    cart.open(trigger || document.activeElement);
  }

  window.FMCart = {
    addVariant: addVariant,
    setVariantQuantity: setVariantQuantity,
    formatMoney: formatMoney,
    updateHeaderCart: updateHeaderCart,
    beginOptimisticHeaderUpdate: beginOptimisticHeaderUpdate,
    settleOptimisticHeaderUpdate: settleOptimisticHeaderUpdate,
    fetchCart: fetchCart,
    openCart: openCart,
    clearCart: clearCart
  };

  var cartClearPreviousFocus = null;

  function openCartClearConfirmation(trigger) {
    var drawer = trigger && trigger.closest('cart-drawer');
    var modal = drawer && drawer.querySelector('[data-fm-cart-clear-confirm]');
    if (!modal) return;

    cartClearPreviousFocus = trigger;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    var cancelButton = modal.querySelector('.fm-cart-clear-confirm__cancel');
    if (cancelButton) cancelButton.focus({ preventScroll: true });
  }

  function closeCartClearConfirmation(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (cartClearPreviousFocus && cartClearPreviousFocus.isConnected) {
      cartClearPreviousFocus.focus({ preventScroll: true });
    }
    cartClearPreviousFocus = null;
  }

  document.addEventListener('click', function (event) {
    var cartLink = event.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (cartLink) {
      event.preventDefault();
      openCart(cartLink);
      return;
    }

    var quantityButton = event.target.closest('[data-fm-cart-quantity-minus], [data-fm-cart-quantity-plus]');
    if (quantityButton) {
      event.preventDefault();
      var variantId = quantityButton.getAttribute('data-variant-id');
      var currentQuantity = Number(quantityButton.getAttribute('data-current-quantity')) || 0;
      var nextQuantity = quantityButton.hasAttribute('data-fm-cart-quantity-plus')
        ? currentQuantity + 1
        : Math.max(currentQuantity - 1, 0);
      var quantityControl = quantityButton.closest('.fm-cart-family__quantity');

      if (quantityControl) {
        quantityControl.querySelectorAll('button').forEach(function (button) {
          button.disabled = true;
        });
      }

      setVariantQuantity(variantId, nextQuantity, {
        button: quantityButton,
        openDrawer: true
      }).catch(function () {
        if (quantityControl) {
          quantityControl.querySelectorAll('button').forEach(function (button) {
            button.disabled = false;
          });
        }
      });
      return;
    }

    var clearButton = event.target.closest('[data-fm-cart-clear]');
    if (clearButton) {
      event.preventDefault();
      openCartClearConfirmation(clearButton);
      return;
    }

    var clearCancelButton = event.target.closest('[data-fm-cart-clear-cancel]');
    if (clearCancelButton) {
      event.preventDefault();
      closeCartClearConfirmation(clearCancelButton.closest('[data-fm-cart-clear-confirm]'));
      return;
    }

    var clearConfirmButton = event.target.closest('[data-fm-cart-clear-confirm-button]');
    if (clearConfirmButton) {
      event.preventDefault();
      clearConfirmButton.disabled = true;
      clearCart({ openDrawer: true }).catch(function () {
        clearConfirmButton.disabled = false;
      });
      return;
    }

    var trigger = event.target.closest('[data-fm-cart-open]');
    if (!trigger) return;

    event.preventDefault();
    openCart(trigger);
  });

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(updateHeaderCart).catch(function () {});
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var modal = document.querySelector('[data-fm-cart-clear-confirm].is-open');
    if (modal) closeCartClearConfirmation(modal);
  });
})();

/* ==========================================================================
   Frescomarché - Product favorites
   ========================================================================== */

(function () {
  var storageKey = 'fm_favorite_products';

  function readFavorites() {
    try {
      var items = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(items) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {
      return;
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function normalizeProduct(button) {
    return {
      id: button.getAttribute('data-product-id') || '',
      handle: button.getAttribute('data-product-handle') || '',
      title: button.getAttribute('data-product-title') || '',
      url: button.getAttribute('data-product-url') || '#',
      image: button.getAttribute('data-product-image') || '',
      price: button.getAttribute('data-product-price') || '',
      family: button.getAttribute('data-product-family') || 'Autres produits'
    };
  }

  function isFavorite(items, id) {
    return items.some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function updateFavoriteCount(items) {
    document.querySelectorAll('[data-fm-favorite-count]').forEach(function (counter) {
      counter.textContent = String(items.length);
      counter.hidden = items.length === 0;
    });
  }

  function syncFavoriteButtons(scope) {
    var root = scope || document;
    var items = readFavorites();
    var favoritesChanged = false;
    var familyByProductId = {};

    root.querySelectorAll('[data-fm-product-id][data-fm-product-family]').forEach(function (card) {
      familyByProductId[String(card.getAttribute('data-fm-product-id') || '')] = card.getAttribute('data-fm-product-family') || '';
    });

    items.forEach(function (item) {
      var migratedFamily = familyByProductId[String(item.id)] || '';
      if (migratedFamily && (!item.family || item.family === 'Autres produits')) {
        item.family = migratedFamily;
        favoritesChanged = true;
      }
    });

    root.querySelectorAll('[data-fm-favorite-toggle]').forEach(function (button) {
      var id = button.getAttribute('data-product-id') || '';
      var active = isFavorite(items, id);
      var title = button.getAttribute('data-product-title') || 'ce produit';
      var family = button.getAttribute('data-product-family') || '';
      var savedProduct = items.find(function (item) {
        return String(item.id) === String(id);
      });

      if (savedProduct && family && (!savedProduct.family || savedProduct.family === 'Autres produits')) {
        savedProduct.family = family;
        favoritesChanged = true;
      }

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', (active ? 'Retirer ' : 'Ajouter ') + title + (active ? ' des favoris' : ' aux favoris'));
    });

    if (favoritesChanged) writeFavorites(items);
    updateFavoriteCount(items);
  }

  function toggleFavorite(button) {
    var product = normalizeProduct(button);
    if (!product.id) return;

    var items = readFavorites();
    if (isFavorite(items, product.id)) {
      items = items.filter(function (item) {
        return String(item.id) !== String(product.id);
      });
    } else {
      items.unshift(product);
    }

    writeFavorites(items);
    syncFavoriteButtons(document);
    renderFavoritesView();
  }

  function shouldShowFavorites() {
    try {
      return new URLSearchParams(window.location.search).get('fm_favorites') === '1';
    } catch (error) {
      return window.location.search.indexOf('fm_favorites=1') !== -1;
    }
  }

  function shouldOpenFavoritesModal() {
    try {
      return new URLSearchParams(window.location.search).get('fm_favorites_popup') === '1';
    } catch (error) {
      return window.location.search.indexOf('fm_favorites_popup=1') !== -1;
    }
  }

  function renderFavoriteCard(product) {
    var image = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
      : '<span class="fm-favorites-view__fallback" aria-hidden="true">+</span>';

    return [
      '<a class="fm-favorites-view__card" href="' + escapeHtml(product.url || '/pages/catalogue') + '">',
      '<span class="fm-favorites-view__media">' + image + '</span>',
      '<span class="fm-favorites-view__body">',
      '<strong>' + escapeHtml(product.title || 'Produit favori') + '</strong>',
      /* Verrou B2B : ne jamais réafficher un prix mémorisé si la page courante
         est verrouillée — un favori enregistré avant validation ne doit pas
         rouvrir la fuite. */
      product.price && !document.querySelector('.fm-catalogue-pro.is-price-locked')
        ? '<span class="fm-favorites-view__price">' + escapeHtml(product.price) + '</span>'
        : '',
      '</span>',
      '</a>'
    ].join('');
  }

  function renderFavoriteModalCard(product) {
    var image = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
      : '<span class="fm-catalogue-favorites-modal__fallback" aria-hidden="true">+</span>';

    return [
      '<article class="fm-catalogue-favorites-modal__product">',
      '<a class="fm-catalogue-favorites-modal__product-link" href="' + escapeHtml(product.url || '/pages/catalogue') + '">',
      '<span class="fm-catalogue-favorites-modal__media">' + image + '</span>',
      '<span class="fm-catalogue-favorites-modal__body">',
      '<strong>' + escapeHtml(product.title || 'Produit favori') + '</strong>',
      product.price ? '<span>' + escapeHtml(product.price) + '</span>' : '',
      '</span>',
      '</a>',
      '<button class="fm-catalogue-favorites-modal__remove" type="button" data-fm-favorite-remove="' + escapeHtml(product.id) + '" aria-label="Retirer ' + escapeHtml(product.title || 'ce produit') + ' des favoris">×</button>',
      '</article>'
    ].join('');
  }

  function groupFavoritesByFamily(items) {
    var preferredOrder = [
      'Légumes', 'Fruits', 'Crémerie', 'Boucherie', 'Charcuterie',
      'Poissonnerie', 'Surgelés', 'Épicerie salée', 'Épicerie sucrée',
      'Boissons', 'Produits du monde', 'Consommables', 'Hygiène',
      'Autres produits'
    ];
    var groups = {};

    items.forEach(function (item) {
      var family = String(item.family || 'Autres produits').trim() || 'Autres produits';
      if (!groups[family]) groups[family] = [];
      groups[family].push(item);
    });

    return Object.keys(groups)
      .sort(function (a, b) {
        var aIndex = preferredOrder.indexOf(a);
        var bIndex = preferredOrder.indexOf(b);
        if (aIndex === -1) aIndex = preferredOrder.length;
        if (bIndex === -1) bIndex = preferredOrder.length;
        return aIndex === bIndex ? a.localeCompare(b, 'fr') : aIndex - bIndex;
      })
      .map(function (family) {
        return { family: family, items: groups[family] };
      });
  }

  function renderFavoriteModalGroups(items) {
    return groupFavoritesByFamily(items).map(function (group) {
      return [
        '<section class="fm-catalogue-favorites-modal__family">',
        '<h2>' + escapeHtml(group.family) + ' <span>(' + group.items.length + ')</span></h2>',
        '<div class="fm-catalogue-favorites-modal__grid">',
        group.items.map(renderFavoriteModalCard).join(''),
        '</div>',
        '</section>'
      ].join('');
    }).join('');
  }

  function renderFavoriteViewGroups(items) {
    return groupFavoritesByFamily(items).map(function (group) {
      return [
        '<section class="fm-favorites-view__family">',
        '<h2>' + escapeHtml(group.family) + '</h2>',
        '<div class="fm-favorites-view__grid">',
        group.items.map(renderFavoriteCard).join(''),
        '</div>',
        '</section>'
      ].join('');
    }).join('');
  }

  var favoriteModalPreviousFocus = null;

  function renderFavoritesModal() {
    var modal = document.querySelector('[data-fm-catalogue-favorites-modal]');
    if (!modal) return;

    var content = modal.querySelector('[data-fm-favorites-modal-content]');
    var items = readFavorites();

    if (!content) return;
    content.innerHTML = items.length
      ? renderFavoriteModalGroups(items)
      : '<div class="fm-catalogue-favorites-modal__empty"><strong>Aucun favori pour le moment</strong><span>Ajoutez des produits avec le cœur pour les retrouver ici.</span></div>';
  }

  function openFavoritesModal(trigger) {
    var modal = document.querySelector('[data-fm-catalogue-favorites-modal]');
    if (!modal) return;

    favoriteModalPreviousFocus = trigger || document.activeElement;
    renderFavoritesModal();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fm-favorites-lock');

    var close = modal.querySelector('[data-fm-favorites-close]');
    if (close) window.setTimeout(function () { close.focus({ preventScroll: true }); }, 30);
  }

  function closeFavoritesModal() {
    var modal = document.querySelector('[data-fm-catalogue-favorites-modal]');
    if (!modal || !modal.classList.contains('is-open')) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fm-favorites-lock');

    if (favoriteModalPreviousFocus && typeof favoriteModalPreviousFocus.focus === 'function') {
      favoriteModalPreviousFocus.focus({ preventScroll: true });
    }
    favoriteModalPreviousFocus = null;
  }

  function renderFavoritesView() {
    if (!shouldShowFavorites()) return;

    var productGrid = document.getElementById('ProductGridContainer');
    var catalogue = document.querySelector('[data-fm-catalogue]');
    var catalogueMain = catalogue ? catalogue.querySelector('[class$="__main"]') : null;
    if (!productGrid && !catalogueMain) return;

    var currentView = document.querySelector('[data-fm-favorites-view]');
    if (currentView) {
      currentView.remove();
    }

    var items = readFavorites();
    var view = document.createElement('section');
    view.className = 'fm-favorites-view';
    view.setAttribute('data-fm-favorites-view', '');
    view.innerHTML = [
      '<div class="fm-favorites-view__head">',
      '<div>',
      '<h1>Mes favoris <span aria-hidden="true">♡</span></h1>',
      '</div>',
      '<a class="fm-favorites-view__back" href="/pages/catalogue">Retour catalogue</a>',
      '</div>',
      items.length
        ? renderFavoriteViewGroups(items)
        : '<div class="fm-favorites-view__empty">Aucun produit favori pour le moment. Ajoutez des produits depuis le catalogue avec le coeur.</div>'
    ].join('');

    if (catalogueMain) {
      Array.prototype.forEach.call(catalogueMain.children, function (child) {
        if (!child.hasAttribute('data-fm-favorites-view')) child.hidden = true;
      });
      catalogueMain.appendChild(view);
    } else {
      productGrid.parentNode.insertBefore(view, productGrid);
    }
    document.body.classList.add('fm-favorites-mode');
  }

  document.addEventListener('click', function (event) {
    var favoritesOpener = event.target.closest('[data-fm-favorites-open]');
    if (favoritesOpener) {
      if (document.querySelector('[data-fm-catalogue-favorites-modal]')) {
        event.preventDefault();
        var activeCartDrawer = document.querySelector('cart-drawer.drawer.active');
        if (activeCartDrawer && typeof activeCartDrawer.close === 'function') {
          activeCartDrawer.close();
        }
        openFavoritesModal(document.querySelector('.fm-header__quick-link[data-fm-favorites-open]') || favoritesOpener);
      }
      return;
    }

    var favoritesClose = event.target.closest('[data-fm-favorites-close]');
    if (favoritesClose) {
      event.preventDefault();
      closeFavoritesModal();
      return;
    }

    var favoritesRemove = event.target.closest('[data-fm-favorite-remove]');
    if (favoritesRemove) {
      event.preventDefault();
      event.stopPropagation();
      var removeId = favoritesRemove.getAttribute('data-fm-favorite-remove') || '';
      var remainingItems = readFavorites().filter(function (item) {
        return String(item.id) !== String(removeId);
      });
      writeFavorites(remainingItems);
      syncFavoriteButtons(document);
      renderFavoritesModal();
      renderFavoritesView();
      return;
    }

    var button = event.target.closest('[data-fm-favorite-toggle]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    toggleFavorite(button);
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncFavoriteButtons(document);
    renderFavoritesView();
    if (shouldOpenFavoritesModal()) openFavoritesModal(null);
  });

  document.addEventListener('shopify:section:load', function (event) {
    syncFavoriteButtons(event.target);
    renderFavoritesView();
    renderFavoritesModal();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeFavoritesModal();
  });
})();

/* ==========================================================================
   Frescomarché - Delivery slot selector
   ========================================================================== */

(function () {
  var storageKey = 'fm_delivery_slot';
  var cutoffMinutes = 30;
  var lockedScrollY = 0;

  function formatIsoDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function capitalize(value) {
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
  }

  function updateSummaries(dateLabel, timeLabel) {
    document.querySelectorAll('[data-fm-delivery-summary-date]').forEach(function (item) {
      item.textContent = dateLabel;
    });

    document.querySelectorAll('[data-fm-delivery-summary-time]').forEach(function (item) {
      item.textContent = timeLabel;
    });
  }

  function updateCartDeliverySlot(slotLabel) {
    document.querySelectorAll('[data-fm-cart-delivery-slot]').forEach(function (item) {
      item.textContent = slotLabel || 'Choisir mon créneau';
    });
    document.querySelectorAll('[data-fm-cart-delivery-slot-input]').forEach(function (input) {
      input.value = slotLabel || '';
    });
    document.querySelectorAll('[data-fm-cart-delivery-confirmation]').forEach(function (card) {
      card.classList.toggle('is-confirmed', Boolean(slotLabel));
      card.classList.toggle('is-required', !slotLabel);
      var status = card.querySelector('[data-fm-cart-delivery-status]');
      var edit = card.querySelector('[data-fm-cart-delivery-edit]');
      if (status) status.textContent = slotLabel ? 'Livraison confirmée' : 'À confirmer avant paiement';
      if (edit) {
        edit.textContent = slotLabel ? 'Modifier' : 'Choisir';
        edit.setAttribute('aria-label', slotLabel ? 'Modifier le créneau de livraison' : 'Choisir un créneau de livraison');
      }
    });
    document.querySelectorAll('[data-fm-cart-checkout]').forEach(function (button) {
      var total = button.getAttribute('data-fm-cart-total') || '';
      button.classList.toggle('is-slot-required', !slotLabel);
      button.type = slotLabel ? 'submit' : 'button';
      if (slotLabel) button.setAttribute('name', 'checkout');
      else button.removeAttribute('name');
      button.textContent = slotLabel ? 'Confirmer et payer · ' + total : 'Choisir un créneau avant de payer';
    });
  }

  function persistCheckoutDeliverySlot(slotLabel) {
    updateCartDeliverySlot(slotLabel);
    var routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return window.fetch(routesRoot + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Créneau de livraison': slotLabel
        }
      })
    }).catch(function () {
      /* Le champ du formulaire panier transmettra aussi le créneau à la commande. */
    }).then(function () {
      return clearCheckoutDeliveryLineProperties();
    });
  }

  /*
   * Le créneau est une information de commande, jamais une caractéristique d'un
   * article. Les anciennes versions du catalogue le copiaient dans une ligne du
   * panier pour le rendre visible au checkout ; cela l'affichait sous un produit.
   * On retire donc uniquement cette ancienne propriété tout en conservant
   * l'attribut de commande « Créneau de livraison » comme source de vérité.
   */
  window.fmClearCheckoutDeliveryLineProperties = clearCheckoutDeliveryLineProperties;
  function clearCheckoutDeliveryLineProperties() {
    var routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return window.fetch(routesRoot + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      return response.json();
    }).then(function (cartData) {
      if (!cartData || !Array.isArray(cartData.items) || !cartData.items.length) return cartData;

      var legacyItems = cartData.items.filter(function (item) {
        return item.properties && Object.prototype.hasOwnProperty.call(item.properties, 'Créneau de livraison');
      });
      if (!legacyItems.length) return cartData;

      return Promise.all(legacyItems.map(function (item) {
        var properties = Object.assign({}, item.properties || {});
        delete properties['Créneau de livraison'];
        return window.fetch(routesRoot + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: properties
          })
        }).then(function (response) {
          return response.json();
        });
      })).then(function () {
        return cartData;
      });
    }).catch(function () {
      /* L’attribut panier reste la source de vérité pour la préparation. */
    });
  }

  window.FMSyncCheckoutDeliverySlot = function () {
    var input = document.querySelector('[data-fm-cart-delivery-slot-input]');
    var slotLabel = input ? input.value.trim() : '';
    if (!slotLabel) {
      try {
        var saved = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
        var savedDate = saved && (saved.date || saved.day);
        var savedTime = saved && (saved.time || saved.slot);
        slotLabel = savedDate && savedTime ? savedDate + ' — ' + savedTime : '';
      } catch (error) {
        slotLabel = '';
      }
    }
    if (!slotLabel) return Promise.resolve();
    return persistCheckoutDeliverySlot(slotLabel);
  };

  function openDeliveryFromCart() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.close === 'function') cartDrawer.close();

    window.setTimeout(function () {
      var opener = document.querySelector('[data-fm-delivery-open]');
      if (opener) opener.click();
    }, 80);
  }

  document.addEventListener('click', function (event) {
    var edit = event.target.closest('[data-fm-cart-delivery-edit]');
    if (edit) {
      event.preventDefault();
      openDeliveryFromCart();
      return;
    }

    var checkout = event.target.closest('[data-fm-cart-checkout]');
    if (!checkout) return;

    var slotInput = document.querySelector('[data-fm-cart-delivery-slot-input]');
    if (slotInput && slotInput.value.trim()) return;

    event.preventDefault();
    openDeliveryFromCart();
  });

  function lockDeliveryPage() {
    if (document.body.classList.contains('fm-global-delivery-open')) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('fm-global-delivery-open');
    document.body.classList.add('fm-global-delivery-open', 'fm-delivery-panel-open');
    document.body.style.top = '-' + lockedScrollY + 'px';
  }

  function unlockDeliveryPage() {
    document.documentElement.classList.remove('fm-global-delivery-open');
    document.body.classList.remove('fm-global-delivery-open');
    document.body.style.removeProperty('top');
    if (!document.querySelector('[data-fm-delivery-panel]:not([hidden])')) {
      document.body.classList.remove('fm-delivery-panel-open');
    }
    window.scrollTo(0, lockedScrollY);
  }

  function closePanel(panel) {
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[data-fm-delivery-panel]:not([hidden])')) {
      unlockDeliveryPage();
    }
  }

  function openPanel(panel) {
    document.querySelectorAll('[data-fm-delivery-panel]:not([hidden])').forEach(function (openPanelItem) {
      if (openPanelItem !== panel) {
        openPanelItem.hidden = true;
        openPanelItem.setAttribute('aria-hidden', 'true');
      }
    });

    if (typeof panel.fmRefreshAvailability === 'function') {
      panel.fmRefreshAvailability();
    }
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    lockDeliveryPage();

    var closeButton = panel.querySelector('[data-fm-delivery-close]');
    if (closeButton) {
      window.requestAnimationFrame(function () {
        try {
          closeButton.focus({ preventScroll: true });
        } catch (error) {
          closeButton.focus();
        }
      });
    }
  }

  function initDeliverySlots(scope) {
    var root = scope || document;
    var panels = root.querySelectorAll('[data-fm-delivery-panel]');

    var saved = null;
    try {
      saved = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
    } catch (error) {
      saved = null;
    }

    panels.forEach(function (panel) {
      if (panel.dataset.fmDeliveryPanelReady === 'true') return;

      panel.classList.add('fm-delivery-panel--viewport');
      panel.setAttribute('aria-hidden', 'true');
      document.body.appendChild(panel);

      var dateButtons = panel.querySelectorAll('[data-fm-delivery-date]');
      var slotButtons = panel.querySelectorAll('[data-fm-delivery-slot-choice]');
      var moreDatesButton = panel.querySelector('[data-fm-delivery-more-dates]');
      var validate = panel.querySelector('[data-fm-delivery-validate]');
      var selectedDate = '';
      var selectedDateIso = '';
      var selectedTime = '';
      var shortDateFormatter = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
      var weekdayFormatter = new Intl.DateTimeFormat('fr-FR', { weekday: 'long' });
      var howToggle = panel.querySelector('[data-fm-delivery-how-toggle]');
      var howContent = panel.querySelector('[data-fm-delivery-how-content]');
      var noteToggle = panel.querySelector('[data-fm-delivery-note-toggle]');
      var noteEditor = panel.querySelector('[data-fm-delivery-note-editor]');
      var noteInput = panel.querySelector('[data-fm-delivery-note-input]');
      var noteSave = panel.querySelector('[data-fm-delivery-note-save]');
      var noteStatus = panel.querySelector('[data-fm-delivery-note-status]');
      var noteLoaded = false;

      if (howToggle && howContent) {
        howToggle.addEventListener('click', function () {
          var willOpen = howContent.hidden;
          howContent.hidden = !willOpen;
          howToggle.setAttribute('aria-expanded', String(willOpen));
        });
      }

      function loadCartNote() {
        if (noteLoaded || !noteInput) return;
        noteLoaded = true;
        var routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        window.fetch(routesRoot + 'cart.js', { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart note unavailable');
            return response.json();
          })
          .then(function (cartData) {
            noteInput.value = cartData.note || '';
            if (cartData.note && noteToggle) noteToggle.textContent = '+ Modifier la note de livraison';
          })
          .catch(function () {
            try {
              noteInput.value = window.localStorage.getItem('fm_delivery_note') || '';
            } catch (error) {
              noteInput.value = '';
            }
          });
      }

      if (noteToggle && noteEditor) {
        noteToggle.addEventListener('click', function () {
          var willOpen = noteEditor.hidden;
          noteEditor.hidden = !willOpen;
          noteToggle.setAttribute('aria-expanded', String(willOpen));
          if (willOpen) {
            loadCartNote();
            window.requestAnimationFrame(function () {
              if (noteInput) noteInput.focus({ preventScroll: true });
            });
          }
        });
      }

      if (noteSave && noteInput) {
        noteSave.addEventListener('click', function () {
          var note = noteInput.value.trim();
          var routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          noteSave.disabled = true;
          if (noteStatus) noteStatus.textContent = 'Enregistrement…';

          window.fetch(routesRoot + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: note })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Cart note update failed');
              return response.json();
            })
            .then(function () {
              try {
                window.localStorage.setItem('fm_delivery_note', note);
              } catch (error) {
                /* The cart note is already saved by Shopify. */
              }
              if (noteStatus) noteStatus.textContent = note ? 'Note enregistrée' : 'Note supprimée';
              if (noteToggle) noteToggle.textContent = note ? '+ Modifier la note de livraison' : '+ Ajouter une note de livraison';
            })
            .catch(function () {
              if (noteStatus) noteStatus.textContent = 'Impossible d’enregistrer. Réessayez.';
            })
            .finally(function () {
              noteSave.disabled = false;
            });
        });
      }

      function hydrateDates() {
        var today = new Date();
        today.setHours(12, 0, 0, 0);

        dateButtons.forEach(function (button) {
          var offset = Number(button.dataset.dayOffset || 0);
          var date = new Date(today);
          date.setDate(today.getDate() + offset);
          var mainLabel = offset === 0
            ? 'Aujourd’hui'
            : offset === 1
              ? 'Demain'
              : capitalize(weekdayFormatter.format(date));
          var shortDate = shortDateFormatter.format(date).replace('.', '');

          button.dataset.dateIso = formatIsoDate(date);
          button.dataset.dateLabel = mainLabel + ' · ' + shortDate;
          button.dataset.dateTimestamp = String(date.getTime());
          var strong = button.querySelector('strong');
          var span = button.querySelector('span');
          if (strong) strong.textContent = mainLabel;
          if (span) span.textContent = shortDate;
        });
      }

      function getSlotStart(dateButton, timeLabel) {
        if (!dateButton) return null;
        var match = String(timeLabel || '').match(/(\d{1,2})h(?:(\d{2}))?/i);
        if (!match) return null;
        var slotDate = new Date(Number(dateButton.dataset.dateTimestamp));
        slotDate.setHours(Number(match[1]), Number(match[2] || 0), 0, 0);
        return slotDate;
      }

      function slotRemainsBookable(dateButton, timeLabel, now) {
        var slotStart = getSlotStart(dateButton, timeLabel);
        if (!slotStart) return true;
        return now.getTime() <= slotStart.getTime() - cutoffMinutes * 60 * 1000;
      }

      function refreshAvailability() {
        var now = new Date();

        dateButtons.forEach(function (button) {
          var hasAvailableSlot = Array.prototype.some.call(slotButtons, function (slotButton) {
            return slotRemainsBookable(button, slotButton.dataset.timeLabel, now);
          });
          button.disabled = !hasAvailableSlot;
          button.setAttribute('aria-disabled', String(!hasAvailableSlot));
        });

        var activeDate = Array.prototype.find.call(dateButtons, function (button) {
          return button.classList.contains('is-active') && !button.disabled;
        });
        if (!activeDate) {
          activeDate = Array.prototype.find.call(dateButtons, function (button) {
            return !button.disabled;
          }) || null;
          dateButtons.forEach(function (button) {
            button.classList.toggle('is-active', button === activeDate);
          });
        }
        if (!activeDate) return;

        selectedDate = activeDate.dataset.dateLabel;
        selectedDateIso = activeDate.dataset.dateIso;

        slotButtons.forEach(function (button) {
          var available = slotRemainsBookable(activeDate, button.dataset.timeLabel, now);
          button.disabled = !available;
          button.setAttribute('aria-disabled', String(!available));
        });

        var activeSlot = Array.prototype.find.call(slotButtons, function (button) {
          return button.classList.contains('is-active') && !button.disabled;
        });
        if (!activeSlot) {
          activeSlot = Array.prototype.find.call(slotButtons, function (button) {
            return !button.disabled;
          }) || null;
          slotButtons.forEach(function (button) {
            button.classList.toggle('is-active', button === activeSlot);
          });
        }
        selectedTime = activeSlot ? activeSlot.dataset.timeLabel : '';
        if (validate) validate.disabled = !activeSlot;
      }

      function revealMoreDates(shouldScroll) {
        var firstExtraDate = panel.querySelector('[data-fm-delivery-date][hidden]');
        dateButtons.forEach(function (button) {
          button.hidden = false;
        });
        if (moreDatesButton) {
          moreDatesButton.setAttribute('aria-expanded', 'true');
          moreDatesButton.hidden = true;
        }
        if (shouldScroll && firstExtraDate) {
          window.requestAnimationFrame(function () {
            try {
              firstExtraDate.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            } catch (error) {
              firstExtraDate.parentElement.scrollLeft = firstExtraDate.offsetLeft;
            }
          });
        }
      }

      hydrateDates();

      if (saved && (saved.dateIso || saved.date || saved.day)) {
        var savedDateButton = Array.prototype.find.call(dateButtons, function (button) {
          return (saved.dateIso && button.dataset.dateIso === saved.dateIso)
            || button.dataset.dateLabel === (saved.date || saved.day);
        });
        if (savedDateButton) {
          dateButtons.forEach(function (button) {
            button.classList.toggle('is-active', button === savedDateButton);
          });
          if (savedDateButton.hidden) revealMoreDates(false);
        }
      }

      selectedTime = saved && (saved.time || saved.slot) ? (saved.time || saved.slot) : '';
      if (selectedTime) {
        slotButtons.forEach(function (button) {
          button.classList.toggle('is-active', button.dataset.timeLabel === selectedTime);
        });
      }

      refreshAvailability();
      if (selectedDate && selectedTime) {
        updateSummaries(selectedDate, selectedTime);
        persistCheckoutDeliverySlot(selectedDate + ' — ' + selectedTime);
      }
      panel.fmRefreshAvailability = refreshAvailability;

      dateButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;
          dateButtons.forEach(function (otherButton) {
            otherButton.classList.toggle('is-active', otherButton === button);
          });
          refreshAvailability();
        });
      });

      if (moreDatesButton) {
        moreDatesButton.addEventListener('click', function () {
          revealMoreDates(true);
        });
      }

      slotButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;
          selectedTime = button.getAttribute('data-time-label') || button.textContent.trim();
          slotButtons.forEach(function (otherButton) {
            otherButton.classList.toggle('is-active', otherButton === button);
          });
        });
      });

      panel.querySelectorAll('[data-fm-delivery-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          closePanel(panel);
        });
      });

      if (validate) {
        validate.addEventListener('click', function () {
          refreshAvailability();
          var selectedSlot = Array.prototype.find.call(slotButtons, function (button) {
            return button.dataset.timeLabel === selectedTime && !button.disabled;
          });
          if (!selectedSlot) return;

          if (selectedDate && selectedTime) {
            updateSummaries(selectedDate, selectedTime);
            var checkoutSlotLabel = selectedDate + ' — ' + selectedTime;
            updateCartDeliverySlot(checkoutSlotLabel);
            persistCheckoutDeliverySlot(checkoutSlotLabel);
            try {
              window.localStorage.setItem(storageKey, JSON.stringify({
                date: selectedDate,
                dateIso: selectedDateIso,
                time: selectedTime,
                day: selectedDate,
                slot: selectedTime
              }));
              document.dispatchEvent(new CustomEvent('fm:slot:saved'));
            } catch (error) {
              /* Le panier Shopify conserve malgré tout le créneau sélectionné. */
            }
          }

          closePanel(panel);
        });
      }

      panel.dataset.fmDeliveryPanelReady = 'true';
    });

    document.querySelectorAll('[data-fm-delivery-open]:not([data-fm-delivery-open-ready])').forEach(function (button) {
      var targetId = button.getAttribute('aria-controls');
      var panel = targetId ? document.getElementById(targetId) : document.querySelector('[data-fm-delivery-panel]');
      if (!panel) return;

      button.addEventListener('click', function () {
        openPanel(panel);
      });

      button.dataset.fmDeliveryOpenReady = 'true';
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-fm-delivery-panel]:not([hidden])').forEach(function (panel) {
      closePanel(panel);
    });
  });

  window.addEventListener('pageshow', function () {
    if (!document.querySelector('[data-fm-delivery-panel]:not([hidden])')) {
      document.documentElement.classList.remove('fm-global-delivery-open');
      document.body.classList.remove('fm-global-delivery-open', 'fm-delivery-panel-open');
      document.body.style.removeProperty('top');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initDeliverySlots(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initDeliverySlots(event.target);
  });
})();

/* ==========================================================================
   Frescomarché - Hero slider
   ========================================================================== */

(function () {
  function findHeroSliders(root) {
    const scope = root || document;
    const sliders = [];

    if (scope.matches && scope.matches('[data-fm-hero-slider]:not([data-fm-hero-ready])')) {
      sliders.push(scope);
    }

    scope.querySelectorAll('[data-fm-hero-slider]:not([data-fm-hero-ready])').forEach(function (hero) {
      if (!sliders.includes(hero)) {
        sliders.push(hero);
      }
    });

    return sliders;
  }

  function initHeroSlider(scope) {
    const root = scope || document;
    const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    findHeroSliders(root).forEach(function (hero) {
      const slides = Array.prototype.slice.call(hero.querySelectorAll('[data-fm-hero-slide]'));
      const dots = Array.prototype.slice.call(hero.querySelectorAll('[data-fm-hero-dot]'));
      const interval = Math.max(parseInt(hero.getAttribute('data-fm-hero-interval'), 10) || 4500, 2500);
      const canAutoplay = hero.getAttribute('data-fm-hero-autoplay') !== 'false' && !prefersReducedMotion;
      let activeIndex = Math.max(slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      }), 0);
      let timer = null;
      let paused = false;

      function setActive(index) {
        const nextIndex = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === nextIndex);
        });

        dots.forEach(function (dot, dotIndex) {
          const isActive = dotIndex === nextIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        activeIndex = nextIndex;
      }

      function stop() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }

      function start() {
        if (!canAutoplay || paused || timer || slides.length < 2) return;
        timer = window.setInterval(function () {
          setActive(activeIndex + 1);
        }, interval);
      }

      if (slides.length < 2) {
        hero.setAttribute('data-fm-hero-ready', 'true');
        return;
      }

      setActive(activeIndex);

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          setActive(index);
          stop();
          start();
        });
      });

      hero.addEventListener('mouseenter', function () {
        paused = true;
        stop();
      });

      hero.addEventListener('mouseleave', function () {
        paused = false;
        start();
      });

      hero.addEventListener('focusin', function () {
        paused = true;
        stop();
      });

      hero.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (hero.contains(document.activeElement)) return;
          paused = false;
          start();
        }, 0);
      });

      function handleVisibilityChange() {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      }

      document.addEventListener('visibilitychange', handleVisibilityChange);

      hero.fmHeroSliderCleanup = function () {
        stop();
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        delete hero.fmHeroSliderCleanup;
      };

      hero.setAttribute('data-fm-hero-ready', 'true');
      start();
    });
  }

  function bootHeroSlider() {
    initHeroSlider(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootHeroSlider);
  } else {
    bootHeroSlider();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHeroSlider(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target.matches && event.target.matches('[data-fm-hero-slider]')
      ? event.target
      : event.target.querySelector('[data-fm-hero-slider]');
    if (root && typeof root.fmHeroSliderCleanup === 'function') {
      root.fmHeroSliderCleanup();
    }
  });
})();

/* ==========================================================================
   Frescomarché - Catalogue Pro
   ========================================================================== */

(function () {
  function initCatalogue(root) {
    if (!root || root.dataset.fmCatalogueReady === 'true') return;

    document.body.classList.add('fm-catalogue-app-active');

    const search = root.querySelector('[data-fm-catalogue-search]') || document.querySelector('[data-fm-header] [data-fm-header-search-input]');
    const empty = root.querySelector('[data-fm-catalogue-empty]');
    const homeEmpty = root.querySelector('[data-fm-catalogue-home-empty]');
    const listResults = root.querySelector('[data-fm-catalogue-list-results]');
    const drawer = root.querySelector('[data-fm-catalogue-drawer]');
    const drawerContent = root.querySelector('[data-fm-catalogue-drawer-content]');
    const closeButtons = root.querySelectorAll('[data-fm-catalogue-close]');
    const authGateModal = root.querySelector('[data-fm-auth-gate-modal]');
    const authGateClose = root.querySelector('[data-fm-auth-gate-close]');
    const mainScroller = root.querySelector('[data-fm-catalogue-main]');
    const sideScroller = root.querySelector('aside');
    let currentRailId = null;
    let previousFocus = null;
    let searchTimer = null;
    let searchRequestSequence = 0;
    let searchAbortController = null;

    function setMobileNavigation(open) {
      root.classList.toggle('is-mobile-nav-open', open);
      document.body.classList.toggle('fm-catalogue-lock', open);
      root.querySelectorAll('[data-fm-catalogue-mobile-open]').forEach(function (button) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      if (!open && window.location.hash === '#' + root.id + '-sidebar') {
        window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
      }

      if (open) {
        const closeButton = root.querySelector('[data-fm-catalogue-mobile-close]');
        if (closeButton) {
          window.setTimeout(function () {
            closeButton.focus({ preventScroll: true });
          }, 30);
        }
      }
    }

    function setAuthGate(open) {
      if (!authGateModal) return;

      authGateModal.classList.toggle('is-open', open);
      authGateModal.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('fm-catalogue-lock', open);

      if (open) {
        window.setTimeout(function () {
          var firstAction = authGateModal.querySelector('a, button');
          if (firstAction) firstAction.focus({ preventScroll: true });
        }, 30);
      }
    }

    function isDesktopCatalogue() {
      return window.matchMedia('(min-width: 780px)').matches;
    }

    function updateViewportHeight() {
      if (!isDesktopCatalogue()) {
        root.style.removeProperty('--fm-catalogue-viewport-height');
        document.body.classList.remove('fm-catalogue-page-lock');
        return;
      }

      document.body.classList.add('fm-catalogue-page-lock');
      const top = Math.max(root.getBoundingClientRect().top, 0);
      const availableHeight = Math.max(window.innerHeight - top - 1, 560);
      root.style.setProperty('--fm-catalogue-viewport-height', availableHeight + 'px');
    }

    function containWheel(scroller) {
      if (!scroller) return;

      scroller.addEventListener('wheel', function (event) {
        if (!isDesktopCatalogue() || scroller.scrollHeight <= scroller.clientHeight) return;

        const delta = event.deltaY;
        const atTop = scroller.scrollTop <= 0;
        const atBottom = Math.ceil(scroller.scrollTop + scroller.clientHeight) >= scroller.scrollHeight;

        if ((delta < 0 && atTop) || (delta > 0 && atBottom)) {
          event.preventDefault();
        }
      }, { passive: false });
    }

    function resetMainScroll() {
      if (mainScroller && isDesktopCatalogue()) {
        mainScroller.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

    function normalizeText(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[’']/g, ' ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function slugify(value) {
      return normalizeText(value).replace(/\s+/g, '-');
    }

    function getSearchNeedles(term) {
      const normalized = normalizeText(term);
      const needles = [];

      if (normalized) needles.push(normalized);
      if (normalized.length > 3 && normalized.endsWith('s')) {
        needles.push(normalized.slice(0, -1));
      }

      return needles.filter(function (needle, index, source) {
        return needle && source.indexOf(needle) === index;
      });
    }

    function hideListResults() {
      if (!listResults) return;

      listResults.hidden = true;
      listResults.innerHTML = '';
      root.classList.remove('is-list-results');
    }

    function setSearchUrl(term) {
      const url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (/^q\d+$/.test(key)) url.searchParams.delete(key);
      });

      if (term) url.searchParams.set('q0', term);
      window.history.replaceState(null, '', url.pathname + (url.search ? url.search : ''));
    }

    function closeHeaderSearchPanel() {
      const header = document.querySelector('[data-fm-header]');
      if (!header) return;

      const panel = header.querySelector('[data-fm-header-search-panel]');
      header.classList.remove('is-search-open');
      if (panel) panel.hidden = true;
      if (search) search.setAttribute('aria-expanded', 'false');
    }

    function parseSearchResponse(html) {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      return documentFragment.querySelector('[data-fm-catalogue-search-response]');
    }

    function fetchSearchPage(term, page, signal) {
      const params = new URLSearchParams();
      params.set('q', term);
      params.set('type', 'product');
      params.set('options[prefix]', 'last');
      params.set('view', 'catalogue');
      params.set('page', String(page));

      return fetch('/search?' + params.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: signal
      }).then(function (response) {
        if (!response.ok) throw new Error('Recherche indisponible (' + response.status + ')');
        return response.text();
      }).then(parseSearchResponse);
    }

    function buildSearchResults(term, responses) {
      if (!listResults || !responses.length || !responses[0]) return false;

      const firstResponse = responses[0];
      const total = Number(firstResponse.getAttribute('data-total')) || 0;
      const section = document.createElement('section');
      const head = document.createElement('div');
      const headingGroup = document.createElement('div');
      const title = document.createElement('h2');
      const count = document.createElement('p');
      const grid = document.createElement('div');
      let productCount = 0;

      section.className = root.id + '__list-section ' + root.id + '__search-section';
      section.setAttribute('data-fm-catalogue-list-section', '');
      head.className = root.id + '__list-head';
      headingGroup.className = root.id + '__search-heading';
      title.className = root.id + '__list-title';
      title.textContent = 'Résultats pour "' + term + '"';
      count.className = root.id + '__search-count';
      count.textContent = total + ' produit' + (total > 1 ? 's trouvés' : ' trouvé');
      grid.className = root.id + '__list-track ' + root.id + '__search-grid';
      grid.setAttribute('data-fm-catalogue-track', '');

      headingGroup.appendChild(title);
      headingGroup.appendChild(count);
      head.appendChild(headingGroup);
      section.appendChild(head);

      responses.forEach(function (response) {
        if (!response) return;
        const html = response.innerHTML.split('__FM_SID__').join(root.id);
        const holder = document.createElement('div');
        holder.innerHTML = html;

        holder.querySelectorAll('[data-fm-catalogue-search-card]').forEach(function (card) {
          card.hidden = false;
          grid.appendChild(card);
          productCount += 1;
        });

        holder.querySelectorAll('template[data-fm-catalogue-search-template]').forEach(function (template) {
          section.appendChild(template);
        });
      });

      if (productCount) {
        section.insertBefore(grid, section.querySelector('template'));
      } else {
        const emptyMessage = document.createElement('div');
        emptyMessage.className = root.id + '__list-empty';
        emptyMessage.textContent = 'Aucun produit trouvé pour "' + term + '".';
        section.appendChild(emptyMessage);
      }

      listResults.innerHTML = '';
      listResults.appendChild(section);
      listResults.hidden = false;
      root.classList.remove('is-home', 'is-category');
      root.classList.add('is-list-results');

      root.querySelectorAll('[data-fm-catalogue-rail]').forEach(function (rail) {
        rail.hidden = true;
      });
      root.querySelectorAll('.is-active').forEach(function (item) {
        if (item.matches('a, button')) item.classList.remove('is-active');
      });

      if (homeEmpty) homeEmpty.classList.remove('is-visible');
      if (empty) empty.classList.toggle('is-visible', productCount === 0);
      resetMainScroll();
      refreshClonedQuantityControls();
      return true;
    }

    function searchAllProducts(term) {
      const cleanTerm = String(term || '').trim();
      const requestId = ++searchRequestSequence;

      if (searchAbortController) searchAbortController.abort();
      searchAbortController = typeof AbortController === 'function' ? new AbortController() : null;

      if (!cleanTerm) {
        setSearchUrl('');
        hideListResults();
        if (empty) empty.classList.remove('is-visible');
        restoreCurrentView();
        return Promise.resolve(false);
      }

      closeHeaderSearchPanel();
      setSearchUrl(cleanTerm);
      if (homeEmpty) homeEmpty.classList.remove('is-visible');
      if (empty) empty.classList.remove('is-visible');

      if (listResults) {
        listResults.innerHTML = '<section class="' + root.id + '__list-section"><div class="' + root.id + '__search-loading">Recherche des produits…</div></section>';
        listResults.hidden = false;
      }
      root.classList.remove('is-home', 'is-category');
      root.classList.add('is-list-results');
      root.querySelectorAll('[data-fm-catalogue-rail]').forEach(function (rail) { rail.hidden = true; });

      const signal = searchAbortController ? searchAbortController.signal : undefined;
      return fetchSearchPage(cleanTerm, 1, signal).then(function (firstResponse) {
        if (requestId !== searchRequestSequence || !firstResponse) return false;

        /* la page 1 s'affiche immediatement ; les pages suivantes viennent
           completer la liste ensuite, au lieu de tout bloquer en attendant
           jusqu'a 40 pages HTML */
        const pages = Math.max(1, Math.min(Number(firstResponse.getAttribute('data-pages')) || 1, 40));
        const firstShown = buildSearchResults(cleanTerm, [firstResponse]);
        if (pages === 1) return firstShown;

        const requests = [Promise.resolve(firstResponse)];
        for (let page = 2; page <= pages; page += 1) {
          requests.push(fetchSearchPage(cleanTerm, page, signal));
        }
        return Promise.all(requests).then(function (responses) {
          if (!responses || requestId !== searchRequestSequence) return firstShown;
          return buildSearchResults(cleanTerm, responses);
        });
      }).catch(function (error) {
        if (error && error.name === 'AbortError') return false;
        console.error(error);
        if (requestId === searchRequestSequence) filterProducts(cleanTerm);
        return false;
      });
    }

    function getProductKey(card) {
      const opener = card ? card.querySelector('[data-fm-catalogue-open]') : null;
      if (opener) return opener.getAttribute('data-fm-catalogue-open') || '';

      const title = card ? card.querySelector('h3') : null;
      return title ? title.textContent.trim() : '';
    }

    function findProductsForTerm(term) {
      const needles = getSearchNeedles(term);
      const seen = new Set();
      const matches = [];

      if (!needles.length) return matches;

      root.querySelectorAll('[data-fm-catalogue-rail] [data-fm-catalogue-product]').forEach(function (card) {
        const haystack = normalizeText(card.getAttribute('data-search') || card.textContent || '');
        const isMatch = needles.some(function (needle) {
          return haystack.indexOf(needle) !== -1;
        });

        if (!isMatch) return;

        const key = getProductKey(card) || haystack;
        if (seen.has(key)) return;

        seen.add(key);
        matches.push(card);
      });

      return matches.slice(0, 14);
    }

    function getListQueriesFromUrl() {
      const params = new URLSearchParams(window.location.search || '');
      const entries = [];

      params.forEach(function (value, key) {
        if (!/^q\d+$/.test(key) || !String(value || '').trim()) return;
        entries.push({
          index: Number(key.slice(1)),
          value: String(value || '').trim()
        });
      });

      return entries
        .sort(function (a, b) { return a.index - b.index; })
        .map(function (entry) { return entry.value; })
        .filter(function (term, index, source) {
          const normalized = normalizeText(term);
          return normalized && source.findIndex(function (candidate) {
            return normalizeText(candidate) === normalized;
          }) === index;
        })
        .slice(0, 8);
    }

    function refreshClonedQuantityControls() {
      if (!window.FMCart || typeof window.FMCart.fetchCart !== 'function') return;

      window.FMCart.fetchCart().then(function (cartData) {
        root.querySelectorAll('[data-fm-catalogue-qty-control][data-variant-id]').forEach(function (control) {
          syncQuantityControls(control.getAttribute('data-variant-id'), cartData);
        });
      }).catch(function () {});
    }

    function renderListResults(terms) {
      if (!listResults || !Array.isArray(terms) || !terms.length) return false;

      listResults.innerHTML = '';
      let totalMatches = 0;

      terms.forEach(function (term) {
        const matches = findProductsForTerm(term);
        const section = document.createElement('section');
        const head = document.createElement('div');
        const title = document.createElement('h2');
        const count = document.createElement('span');

        section.className = root.id + '__list-section';
        section.setAttribute('data-fm-catalogue-list-section', '');
        head.className = root.id + '__list-head';
        title.className = root.id + '__list-title';
        title.textContent = term;
        count.className = root.id + '__list-count';
        count.textContent = matches.length ? matches.length + ' produit' + (matches.length > 1 ? 's' : '') : 'Aucun produit';

        head.appendChild(title);
        head.appendChild(count);
        section.appendChild(head);

        if (matches.length) {
          const track = document.createElement('div');
          track.className = root.id + '__list-track';
          track.setAttribute('data-fm-catalogue-track', '');

          matches.forEach(function (card) {
            const clone = card.cloneNode(true);
            clone.hidden = false;
            track.appendChild(clone);
          });

          totalMatches += matches.length;
          section.appendChild(track);
        } else {
          const emptyMessage = document.createElement('div');
          emptyMessage.className = root.id + '__list-empty';
          emptyMessage.textContent = 'Aucun produit trouve pour "' + term + '". Essayez un mot plus simple ou une autre orthographe.';
          section.appendChild(emptyMessage);
        }

        listResults.appendChild(section);
      });

      root.classList.remove('is-home', 'is-category');
      root.classList.add('is-list-results');
      listResults.hidden = false;

      root.querySelectorAll('[data-fm-catalogue-rail]').forEach(function (rail) {
        rail.hidden = true;
        rail.querySelectorAll('[data-fm-catalogue-product]').forEach(function (card) {
          card.hidden = false;
        });
      });

      root.querySelectorAll('.is-active').forEach(function (item) {
        if (item.matches('a, button')) item.classList.remove('is-active');
      });

      if (homeEmpty) homeEmpty.classList.remove('is-visible');
      if (empty) empty.classList.toggle('is-visible', totalMatches === 0);
      if (search) search.value = terms.join(', ');

      resetMainScroll();
      refreshClonedQuantityControls();
      return true;
    }

    function showHomeRails() {
      hideListResults();
      currentRailId = null;
      root.classList.add('is-home');
      root.classList.remove('is-category');

      let visibleHomeRails = 0;
      root.querySelectorAll('[data-fm-catalogue-rail]').forEach(function (rail) {
        const isHomeRail = rail.hasAttribute('data-fm-catalogue-home-rail');
        const shouldShow = isHomeRail;
        rail.hidden = !shouldShow;
        if (shouldShow) visibleHomeRails += 1;
      });

      if (homeEmpty) {
        homeEmpty.classList.toggle('is-visible', visibleHomeRails === 0);
      }

      root.querySelectorAll('[data-fm-catalogue-side-group]').forEach(function (item) {
        const button = item.querySelector('[data-fm-catalogue-subtoggle]');
        item.classList.remove('is-open');
        if (button) button.setAttribute('aria-expanded', 'false');
      });

      resetMainScroll();
    }

    function activateRailNav(railId) {
      root.querySelectorAll('.is-active').forEach(function (item) {
        if (item.matches('a, button')) item.classList.remove('is-active');
      });

      root.querySelectorAll('[data-fm-catalogue-category-link]').forEach(function (item) {
        item.removeAttribute('aria-current');
      });

      root.querySelectorAll('[data-fm-catalogue-side-group]').forEach(function (item) {
        const button = item.querySelector('[data-fm-catalogue-subtoggle]');
        const shouldOpen = button && button.getAttribute('data-fm-catalogue-target') === railId;
        item.classList.toggle('is-open', shouldOpen);
        if (button) button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      });

      const activeButton = root.querySelector('[data-fm-catalogue-category-link][data-fm-catalogue-subtoggle][data-fm-catalogue-target="' + railId + '"]') || root.querySelector('[data-fm-catalogue-category-link][data-fm-catalogue-jump="' + railId + '"]');
      if (activeButton) {
        activeButton.classList.add('is-active');
        if (activeButton.matches('[data-fm-catalogue-category-link]')) activeButton.setAttribute('aria-current', 'true');
      }
    }

    function renderActiveSubcategories(railId, targetRail) {
      root.querySelectorAll('[data-fm-catalogue-active-subcategories]').forEach(function (item) {
        item.remove();
      });

      const categoryButton = root.querySelector('[data-fm-catalogue-subtoggle][data-fm-catalogue-target="' + railId + '"]');
      const group = categoryButton ? categoryButton.closest('[data-fm-catalogue-side-group]') : null;
      const links = group ? group.querySelectorAll('[class$="__sub-link"]') : [];
      const railHead = targetRail ? targetRail.querySelector('[class$="__rail-head"]') : null;
      if (!railHead || !links.length) return;

      const list = document.createElement('div');
      list.className = root.className.split(' ')[0] + '__active-subcategories';
      list.setAttribute('data-fm-catalogue-active-subcategories', '');
      list.setAttribute('aria-label', 'Sous-catégories');

      links.forEach(function (link) {
        const item = document.createElement('span');
        item.className = root.className.split(' ')[0] + '__active-subcategory';
        item.textContent = link.textContent.trim();
        list.appendChild(item);
      });

      railHead.insertAdjacentElement('afterend', list);
    }

    function loadNextRailPage(rail) {
      if (!rail || rail.dataset.fmCatalogueLazyLoading === 'true') return Promise.resolve();
      const track = rail.querySelector('[data-fm-catalogue-track][data-fm-catalogue-lazy-handle]');
      if (!track) return Promise.resolve();

      const currentPage = Number(track.dataset.fmCatalogueLazyPage || 0);
      const totalPages = Number(track.dataset.fmCatalogueLazyPages || 1);
      if (currentPage > 0 && currentPage >= totalPages) return Promise.resolve();

      const nextPage = currentPage + 1;
      const handle = track.dataset.fmCatalogueLazyHandle;
      const tag = track.dataset.fmCatalogueLazyTag || '';
      if (!handle) return Promise.resolve();

      rail.dataset.fmCatalogueLazyLoading = 'true';
      const collectionPath = '/collections/' + encodeURIComponent(handle) + (tag ? '/' + encodeURIComponent(tag) : '');
      return window.fetch(collectionPath + '?view=catalogue&page=' + nextPage, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Catalogue collection unavailable');
          return response.text();
        })
        .then(function (html) {
          const preparedHtml = html.split('__FM_SID__').join(root.id);
          const documentResult = new DOMParser().parseFromString(preparedHtml, 'text/html');
          const responseRoot = documentResult.querySelector('[data-fm-catalogue-collection-response]');
          const meta = responseRoot && responseRoot.querySelector('[data-fm-catalogue-response-meta]');
          const items = responseRoot && responseRoot.querySelector('[data-fm-catalogue-response-items]');
          if (!meta || !items) throw new Error('Invalid catalogue response');

          Array.from(items.children).forEach(function (item) {
            track.appendChild(document.importNode(item, true));
          });
          track.dataset.fmCatalogueLazyPage = meta.dataset.page || String(nextPage);
          track.dataset.fmCatalogueLazyPages = meta.dataset.pages || String(nextPage);
          refreshClonedQuantityControls();
        })
        .catch(function () {
          track.dataset.fmCatalogueLazyPages = String(currentPage);
        })
        .finally(function () {
          delete rail.dataset.fmCatalogueLazyLoading;
        });
    }

    function ensureRailLoaded(rail) {
      if (!rail) return;
      loadNextRailPage(rail);
    }

    root.querySelectorAll('[data-fm-catalogue-track][data-fm-catalogue-lazy-handle]').forEach(function (track) {
      track.addEventListener('scroll', function () {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - Math.max(180, track.clientWidth * 0.35)) {
          loadNextRailPage(track.closest('[data-fm-catalogue-rail]'));
        }
      }, { passive: true });
    });

    function showSingleRail(railId) {
      const targetRail = railId ? document.getElementById(railId) : null;
      if (!targetRail) return;

      hideListResults();
      currentRailId = railId;
      root.classList.remove('is-home');
      root.classList.add('is-category');
      if (homeEmpty) homeEmpty.classList.remove('is-visible');

      let visibleSubrailCount = 0;
      root.querySelectorAll('[data-fm-catalogue-rail]').forEach(function (rail) {
        const isChildRail = rail.getAttribute('data-fm-catalogue-subrail-parent') === railId;
        rail.hidden = !isChildRail;
        if (isChildRail) {
          visibleSubrailCount += 1;
          ensureRailLoaded(rail);
        }
      });

      if (visibleSubrailCount === 0) {
        targetRail.hidden = false;
        ensureRailLoaded(targetRail);
      }

      activateRailNav(railId);
      if (homeEmpty) {
        homeEmpty.textContent = 'Aucune sous-catégorie disponible pour cette catégorie.';
        homeEmpty.classList.toggle('is-visible', visibleSubrailCount === 0);
      }
      resetMainScroll();
    }

    function showSubcategoryRail(parentRailId, subcategoryHandle) {
      let targetRail = root.querySelector(
        '[data-fm-catalogue-subrail-parent="' + CSS.escape(parentRailId || '') + '"]' +
        '[data-fm-catalogue-subcategory-handle="' + CSS.escape(subcategoryHandle || '') + '"]'
      );
      if (!targetRail) {
        const categoryButton = root.querySelector('[data-fm-catalogue-subtoggle][data-fm-catalogue-target="' + CSS.escape(parentRailId || '') + '"]');
        const group = categoryButton ? categoryButton.closest('[data-fm-catalogue-side-group]') : null;
        const links = group ? Array.from(group.querySelectorAll('[class$="__sub-link"]')) : [];
        const linkIndex = links.findIndex(function (link) {
          const handle = link.getAttribute('data-fm-catalogue-subcategory') || new URL(link.href, window.location.origin).pathname.split('/').filter(Boolean).pop();
          return handle === subcategoryHandle;
        });
        const childRails = Array.from(root.querySelectorAll('[data-fm-catalogue-subrail-parent="' + CSS.escape(parentRailId || '') + '"]'));
        if (linkIndex >= 0) targetRail = childRails[linkIndex] || null;
      }
      if (!targetRail) return false;

      hideListResults();
      currentRailId = parentRailId;
      root.classList.remove('is-home');
      root.classList.add('is-category');
      if (homeEmpty) homeEmpty.classList.remove('is-visible');

      root.querySelectorAll('[data-fm-catalogue-rail]').forEach(function (rail) {
        rail.hidden = rail !== targetRail;
      });
      ensureRailLoaded(targetRail);

      activateRailNav(parentRailId);
      let activeLink = root.querySelector(
        '[data-fm-catalogue-subcategory-link][data-fm-catalogue-parent="' + CSS.escape(parentRailId || '') + '"]' +
        '[data-fm-catalogue-subcategory="' + CSS.escape(subcategoryHandle || '') + '"]'
      );
      if (!activeLink) {
        const categoryButton = root.querySelector('[data-fm-catalogue-subtoggle][data-fm-catalogue-target="' + CSS.escape(parentRailId || '') + '"]');
        const group = categoryButton ? categoryButton.closest('[data-fm-catalogue-side-group]') : null;
        activeLink = group ? Array.from(group.querySelectorAll('[class$="__sub-link"]')).find(function (link) {
          return new URL(link.href, window.location.origin).pathname.split('/').filter(Boolean).pop() === subcategoryHandle;
        }) : null;
      }
      if (activeLink) {
        activeLink.classList.add('is-active');
        activeLink.setAttribute('aria-current', 'page');
      }

      resetMainScroll();
      return true;
    }

    function setCatalogueViewUrl(categoryHandle, subcategoryHandle, replace) {
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('rayon');
      url.searchParams.delete('sous-categorie');
      if (categoryHandle) url.searchParams.set('rayon', categoryHandle);
      if (subcategoryHandle) url.searchParams.set('sous-categorie', subcategoryHandle);
      window.history[replace ? 'replaceState' : 'pushState'](
        { fmCatalogueCategory: categoryHandle || '', fmCatalogueSubcategory: subcategoryHandle || '' },
        '',
        url.pathname + url.search
      );
    }

    function restoreCatalogueViewFromUrl() {
      const params = new URLSearchParams(window.location.search || '');
      const categoryHandle = params.get('rayon') || '';
      const subcategoryHandle = params.get('sous-categorie') || '';
      if (!categoryHandle) return false;

      let categoryRail = root.querySelector('[data-fm-catalogue-category-handle="' + CSS.escape(categoryHandle) + '"]');
      if (!categoryRail) {
        categoryRail = Array.from(root.querySelectorAll('[data-fm-catalogue-category-rail]')).find(function (rail) {
          return slugify(rail.getAttribute('data-rail-title') || '') === categoryHandle;
        }) || null;
      }
      if (!categoryRail) return false;
      const railId = categoryRail.id;

      if (subcategoryHandle && showSubcategoryRail(railId, subcategoryHandle)) return true;
      showSingleRail(railId);
      return true;
    }

    function restoreCurrentView() {
      if (currentRailId) {
        showSingleRail(currentRailId);
      } else {
        showHomeRails();
      }
    }

    function setDrawer(open) {
      if (!drawer) return;

      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('fm-catalogue-lock', open);
      document.body.classList.toggle('fm-catalogue-product-open', open);

      if (open) {
        const firstFocusable = drawer.querySelector('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) {
          window.setTimeout(function () {
            firstFocusable.focus({ preventScroll: true });
          }, 30);
        }
      } else if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus({ preventScroll: true });
      }
    }

    function openProduct(templateId) {
      const template = document.getElementById(templateId);
      if (!template || !drawerContent) return;

      previousFocus = document.activeElement;
      drawerContent.innerHTML = '';
      drawerContent.appendChild(template.content.cloneNode(true));
      setDrawer(true);
      refreshClonedQuantityControls();
    }

    function openProductFromHandle(handle) {
      if (!handle) return Promise.resolve(false);
      return window.fetch('/products/' + encodeURIComponent(handle) + '?view=catalogue', {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Catalogue product unavailable');
          return response.text();
        })
        .then(function (html) {
          const preparedHtml = html.split('__FM_SID__').join(root.id);
          const documentResult = new DOMParser().parseFromString(preparedHtml, 'text/html');
          const responseRoot = documentResult.querySelector('[data-fm-catalogue-product-response]');
          if (!responseRoot) return false;

          const detailCard = responseRoot.querySelector('[data-fm-catalogue-product-detail]');
          const templateId = detailCard && detailCard.getAttribute('data-fm-catalogue-product-detail');
          const holder = document.createElement('div');
          holder.hidden = true;
          holder.setAttribute('data-fm-catalogue-direct-product', handle);
          Array.from(responseRoot.children).forEach(function (item) {
            holder.appendChild(document.importNode(item, true));
          });
          root.appendChild(holder);
          if (!templateId) return false;
          openProduct(templateId);
          return true;
        })
        .catch(function () {
          return false;
        });
    }

    function closeProduct() {
      setDrawer(false);
    }

    function setCartButtonState(button, state, label) {
      if (!button) return;

      if (!button.dataset.fmOriginalLabel) {
        button.dataset.fmOriginalLabel = button.textContent.trim();
      }

      button.classList.toggle('is-loading', state === 'loading');
      button.classList.toggle('is-added', state === 'added');
      button.disabled = state === 'loading';
      button.textContent = label || button.dataset.fmOriginalLabel;
    }

    function renderQuantityControls(variantId, quantity) {
      if (!variantId) return;
      quantity = Math.max(Number(quantity) || 0, 0);
      root.querySelectorAll('[data-fm-catalogue-qty-control][data-variant-id]').forEach(function (control) {
        if (String(control.getAttribute('data-variant-id')) !== String(variantId)) return;

        var title = control.getAttribute('data-product-title') || 'ce produit';
        var value = control.querySelector('[data-fm-catalogue-qty-value] strong');
        var numberValue = control.querySelector('[data-fm-catalogue-qty-number]');
        var unit = control.querySelector('[data-fm-catalogue-qty-unit]');
        var plus = control.querySelector('[data-fm-catalogue-qty-plus]');
        var minus = control.querySelector('[data-fm-catalogue-qty-minus]');

        control.dataset.fmQuantity = String(quantity);
        control.classList.toggle('has-quantity', quantity > 0);

        if (numberValue) {
          if (numberValue.tagName === 'INPUT') {
            if (numberValue.value !== String(quantity) && numberValue !== document.activeElement) {
              numberValue.value = String(quantity);
            }
          } else {
            numberValue.textContent = String(quantity);
          }
        } else if (value) {
          value.textContent = String(quantity);
        }
        if (unit) {
          // l'unité réelle (kg, Colis, Barquette…) est posée par le Liquid en
          // data-unit-one/data-unit-many ; « Unité(s) » n'est qu'un secours
          unit.textContent = quantity > 1
            ? (unit.getAttribute('data-unit-many') || 'Unités')
            : (unit.getAttribute('data-unit-one') || 'Unité');
        }
        if (plus) plus.setAttribute('aria-label', 'Ajouter ' + title + ' au panier');
        if (minus) {
          minus.disabled = quantity <= 0;
          minus.setAttribute('aria-label', 'Retirer ' + title + ' du panier');
        }
      });
    }

    function syncQuantityControls(variantId, cartData) {
      if (!variantId || !cartData || !Array.isArray(cartData.items)) return;

      var line = cartData.items.find(function (item) {
        return String(item.variant_id) === String(variantId);
      });
      var confirmed = line ? Number(line.quantity) || 0 : 0;
      quantityServerBase[variantId] = confirmed;
      /* des taps sont en attente ou en vol : ne pas ecraser l'intention */
      if (quantityCommitTimers[variantId] || quantityRequestQueues[variantId]) return;
      quantityDesired[variantId] = confirmed;
      renderQuantityControls(variantId, confirmed);
    }

    function currentQuantityForVariant(variantId) {
      var quantity = 0;
      root.querySelectorAll('[data-fm-catalogue-qty-control][data-variant-id]').forEach(function (control) {
        if (String(control.getAttribute('data-variant-id')) !== String(variantId)) return;
        quantity = Math.max(quantity, Number(control.dataset.fmQuantity) || 0);
      });
      return quantity;
    }

    var quantityRequestQueues = {};
    var quantityRevisions = {};
    var quantityCommitTimers = {};
    var quantityPendingSettles = {};
    var quantityServerBase = {};
    var quantityDesired = {};

    function settleQuantityHeader(variantId, count) {
      var pending = quantityPendingSettles[variantId] || 0;
      var n = Math.min(typeof count === 'number' ? count : pending, pending);
      quantityPendingSettles[variantId] = pending - n;
      if (!window.FMCart || typeof window.FMCart.settleOptimisticHeaderUpdate !== 'function') return;
      for (var i = 0; i < n; i += 1) window.FMCart.settleOptimisticHeaderUpdate();
    }

    function applyServerQuantity(variantId, cartData, revision) {
      if (!cartData || !Array.isArray(cartData.items)) return;
      var line = cartData.items.find(function (item) {
        return String(item.variant_id) === String(variantId);
      });
      var confirmed = line ? Number(line.quantity) || 0 : 0;
      quantityServerBase[variantId] = confirmed;
      /* on ne re-rend l'UI que si aucune intention plus recente n'attend */
      if (quantityRevisions[variantId] === revision && !quantityCommitTimers[variantId]) {
        quantityDesired[variantId] = confirmed;
        renderQuantityControls(variantId, confirmed);
      }
    }

    /* Envoie UNE requete avec la quantite finale voulue, au lieu d'une par
       tap. L'intention (quantityDesired) est suivie PAR VARIANTE, hors DOM :
       ni un re-rendu de cartes (lazy-load, recherche, drawer) ni un
       changement de variante du drawer ne peuvent la perdre ou l'ecraser. */
    function commitQuantity(variantId, trigger) {
      if (!variantId || !window.FMCart) return;

      var revision = quantityRevisions[variantId] || 0;
      var settles = quantityPendingSettles[variantId] || 0;

      var previousRequest = quantityRequestQueues[variantId] || Promise.resolve();
      var request = previousRequest
        .catch(function () {})
        .then(function () {
          var serverBase = Number(quantityServerBase[variantId]) || 0;
          var wanted = Number(quantityDesired[variantId]);
          if (!isFinite(wanted)) wanted = serverBase;
          if (wanted === serverBase) return null;
          if (serverBase === 0 && wanted > 0) {
            return window.FMCart.addVariant(variantId, { button: trigger, quantity: wanted, openDrawer: false });
          }
          if (typeof window.FMCart.setVariantQuantity === 'function') {
            return window.FMCart.setVariantQuantity(variantId, wanted, { button: trigger, openDrawer: false });
          }
          return Promise.reject(new Error('Mise à jour du panier indisponible.'));
        });

      quantityRequestQueues[variantId] = request;

      request
        .then(function (cartData) {
          if (cartData) applyServerQuantity(variantId, cartData, revision);
        })
        .catch(function (error) {
          console.error(error);
          if (window.FMCart && typeof window.FMCart.fetchCart === 'function') {
            window.FMCart.fetchCart().then(function (cartData) {
              applyServerQuantity(variantId, cartData, revision);
            }).catch(function () {});
          }
        })
        .finally(function () {
          settleQuantityHeader(variantId, settles);
          if (quantityRequestQueues[variantId] === request) delete quantityRequestQueues[variantId];
        });
    }

    function scheduleQuantityCommit(variantId, trigger, delay) {
      if (!variantId) return;
      if (quantityCommitTimers[variantId]) clearTimeout(quantityCommitTimers[variantId]);
      quantityCommitTimers[variantId] = setTimeout(function () {
        delete quantityCommitTimers[variantId];
        commitQuantity(variantId, trigger);
      }, typeof delay === 'number' ? delay : 450);
    }

    function trackOptimisticQuantity(variantId, quantityDelta, unitPrice) {
      if (!quantityDelta) return;
      if (typeof window.FMCart.beginOptimisticHeaderUpdate !== 'function'
        || typeof window.FMCart.settleOptimisticHeaderUpdate !== 'function') return;
      window.FMCart.beginOptimisticHeaderUpdate(quantityDelta * unitPrice, quantityDelta);
      quantityPendingSettles[variantId] = (quantityPendingSettles[variantId] || 0) + 1;
    }

    /* Toute intention (tap ou saisie) passe ici : elle incremente la revision
       — un sync serveur plus ancien ne pourra plus ecraser l'affichage — puis
       programme le commit unique. */
    function registerQuantityIntent(variantId, fromQuantity, toQuantity, unitPrice, trigger, delay) {
      if (quantityServerBase[variantId] === undefined) quantityServerBase[variantId] = fromQuantity;
      quantityDesired[variantId] = toQuantity;
      quantityRevisions[variantId] = (quantityRevisions[variantId] || 0) + 1;
      renderQuantityControls(variantId, toQuantity);
      trackOptimisticQuantity(variantId, toQuantity - fromQuantity, unitPrice);
      scheduleQuantityCommit(variantId, trigger, delay);
    }

    function currentQuantityFor(variantId, control) {
      var desired = Number(quantityDesired[variantId]);
      if (isFinite(desired)) return desired;
      return Number(control.dataset.fmQuantity) || 0;
    }

    function handleQuantityControl(control, direction, trigger) {
      if (!control || (trigger && trigger.disabled)) return;

      var variantId = control.getAttribute('data-variant-id');
      if (!variantId || !window.FMCart || typeof window.FMCart.addVariant !== 'function') return;

      var currentQuantity = currentQuantityFor(variantId, control);
      var nextQuantity = direction > 0 ? currentQuantity + 1 : Math.max(currentQuantity - 1, 0);
      if (nextQuantity === currentQuantity) return;
      var unitPrice = Math.max(Number(control.getAttribute('data-unit-price')) || 0, 0);

      registerQuantityIntent(variantId, currentQuantity, nextQuantity, unitPrice, trigger);
    }

    /* Saisie directe d'une quantite au clavier (input des cartes catalogue). */
    function handleQuantityInput(input) {
      var control = input.closest('[data-fm-catalogue-qty-control]');
      if (!control) return;
      var variantId = control.getAttribute('data-variant-id');
      if (!variantId || !window.FMCart || typeof window.FMCart.addVariant !== 'function') return;

      var currentQuantity = currentQuantityFor(variantId, control);
      var raw = String(input.value).trim();
      if (raw === '') {
        /* champ vide : on restaure, on ne supprime pas silencieusement la ligne */
        renderQuantityControls(variantId, currentQuantity);
        return;
      }
      var wanted = Math.min(Math.max(parseInt(raw, 10) || 0, 0), 999);
      if (wanted === currentQuantity) { renderQuantityControls(variantId, wanted); return; }
      var unitPrice = Math.max(Number(control.getAttribute('data-unit-price')) || 0, 0);

      registerQuantityIntent(variantId, currentQuantity, wanted, unitPrice, null, 200);
    }

    root.addEventListener('change', function (event) {
      var qtyInput = event.target.closest('input[data-fm-catalogue-qty-number]');
      if (qtyInput && root.contains(qtyInput)) handleQuantityInput(qtyInput);
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var qtyInput = event.target.closest('input[data-fm-catalogue-qty-number]');
      if (qtyInput && root.contains(qtyInput)) { event.preventDefault(); qtyInput.blur(); }
    });

    function handleCatalogueCartSubmit(event) {
      const form = event.target.closest('[data-fm-catalogue-cart-form]');
      if (!form || !root.contains(form)) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      if (!window.FMCart || typeof window.FMCart.addVariant !== 'function') {
        console.warn('Frescomarche: moteur panier AJAX introuvable.');
        return;
      }

      const button = form.querySelector('[type="submit"]');
      const variantInput = form.querySelector('[name="id"]');
      const variantId = variantInput ? variantInput.value : '';
      if (!variantId) return;

      setCartButtonState(button, 'loading', 'Ajout...');
      window.FMCart.addVariant(variantId, { button: button, quantity: 1, openDrawer: true })
        .then(function (cartData) {
          closeProduct();
          syncQuantityControls(variantId, cartData);
          setCartButtonState(button, 'added', 'Ajouté');

          window.setTimeout(function () {
            setCartButtonState(button, 'idle');
          }, 1200);
        })
        .catch(function (error) {
          console.error(error);
          setCartButtonState(button, 'error', 'Erreur');

          window.setTimeout(function () {
            setCartButtonState(button, 'idle');
          }, 1600);
        });
    }

    function filterProducts(value) {
      hideListResults();

      const query = normalizeText(value);
      const rails = root.querySelectorAll('[data-fm-catalogue-rail]');
      let visibleCount = 0;

      if (!query) {
        rails.forEach(function (rail) {
          rail.querySelectorAll('[data-fm-catalogue-product]').forEach(function (card) {
            card.hidden = false;
          });
        });
        if (empty) empty.classList.remove('is-visible');
        restoreCurrentView();
        return;
      }

      if (homeEmpty) homeEmpty.classList.remove('is-visible');

      rails.forEach(function (rail) {
        const cards = rail.querySelectorAll('[data-fm-catalogue-product]');
        let railVisible = false;

        cards.forEach(function (card) {
          const haystack = normalizeText(card.getAttribute('data-search') || '');
          const visible = !query || haystack.indexOf(query) !== -1;
          card.hidden = !visible;
          if (visible) {
            railVisible = true;
            visibleCount += 1;
          }
        });

        if (cards.length) {
          rail.hidden = !railVisible;
        }
      });

      if (empty) {
        empty.classList.toggle('is-visible', !!query && visibleCount === 0);
      }
    }

    function scrollToRail(railId) {
      const targetRail = railId ? document.getElementById(railId) : null;
      if (!targetRail) return;

      const main = targetRail.closest('[data-fm-catalogue-main]') || mainScroller;
      const canUseInternalScroll = main && isDesktopCatalogue();

      if (canUseInternalScroll) {
        const targetTop = targetRail.getBoundingClientRect().top - main.getBoundingClientRect().top + main.scrollTop;
        main.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
      } else {
        targetRail.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      if (window.location.hash && window.location.hash.slice(1) === railId) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    root.addEventListener('click', function (event) {
      const mobileNavigationOpener = event.target.closest('[data-fm-catalogue-mobile-open]');
      if (mobileNavigationOpener && root.contains(mobileNavigationOpener)) {
        event.preventDefault();
        setMobileNavigation(true);
        return;
      }

      const mobileNavigationCloser = event.target.closest('[data-fm-catalogue-mobile-close]');
      if (mobileNavigationCloser && root.contains(mobileNavigationCloser)) {
        event.preventDefault();
        setMobileNavigation(false);
        return;
      }

      const mobileMessage = event.target.closest('[data-fm-catalogue-message]');
      if (mobileMessage && root.contains(mobileMessage)) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('fm:whatsapp:open'));
        const whatsappRoot = document.querySelector('.fm-wa');
        if (!whatsappRoot || !whatsappRoot.classList.contains('is-open')) {
          const whatsappLauncher = document.querySelector('[data-fm-wa-launcher]');
          if (whatsappLauncher) whatsappLauncher.click();
        }
        return;
      }

      const authGateTrigger = event.target.closest('[data-fm-auth-gate]');
      if (authGateTrigger && root.contains(authGateTrigger)) {
        event.preventDefault();
        event.stopPropagation();
        setAuthGate(true);
        return;
      }

      const home = event.target.closest('[data-fm-catalogue-home]');
      if (home && root.contains(home)) {
        event.preventDefault();

        root.querySelectorAll('.is-active').forEach(function (item) {
          if (item.matches('a, button')) item.classList.remove('is-active');
        });
        home.classList.add('is-active');
        showHomeRails();
        setCatalogueViewUrl('', '', false);
        setMobileNavigation(false);
        return;
      }

      const subcategoryLink = event.target.closest('[data-fm-catalogue-subcategory-link], [class$="__sub-link"]');
      if (subcategoryLink && root.contains(subcategoryLink)) {
        const sideGroup = subcategoryLink.closest('[data-fm-catalogue-side-group]');
        const categoryButton = sideGroup ? sideGroup.querySelector('[data-fm-catalogue-subtoggle]') : null;
        const parentRailId = subcategoryLink.getAttribute('data-fm-catalogue-parent') || (categoryButton ? categoryButton.getAttribute('data-fm-catalogue-target') : '');
        const subcategoryHandle = subcategoryLink.getAttribute('data-fm-catalogue-subcategory') || new URL(subcategoryLink.href, window.location.origin).pathname.split('/').filter(Boolean).pop();
        if (showSubcategoryRail(parentRailId, subcategoryHandle)) {
          event.preventDefault();
          const parentRail = document.getElementById(parentRailId);
          const categoryHandle = parentRail ? (parentRail.getAttribute('data-fm-catalogue-category-handle') || slugify(parentRail.getAttribute('data-rail-title') || '')) : '';
          setCatalogueViewUrl(categoryHandle, subcategoryHandle, false);
          setMobileNavigation(false);
        } else {
          const directUrl = subcategoryLink.getAttribute('data-fm-catalogue-direct-url');
          if (directUrl) {
            event.preventDefault();
            window.location.assign(directUrl);
          }
        }
        return;
      }

      const qtyPlus = event.target.closest('[data-fm-catalogue-qty-plus]');
      if (qtyPlus && root.contains(qtyPlus)) {
        event.preventDefault();
        event.stopPropagation();
        handleQuantityControl(qtyPlus.closest('[data-fm-catalogue-qty-control]'), 1, qtyPlus);
        return;
      }

      const qtyMinus = event.target.closest('[data-fm-catalogue-qty-minus]');
      if (qtyMinus && root.contains(qtyMinus)) {
        event.preventDefault();
        event.stopPropagation();
        handleQuantityControl(qtyMinus.closest('[data-fm-catalogue-qty-control]'), -1, qtyMinus);
        return;
      }

      const variantOption = event.target.closest('[data-fm-catalogue-variant-option]');
      if (variantOption && root.contains(variantOption) && !variantOption.disabled) {
        event.preventDefault();
        event.stopPropagation();

        const picker = variantOption.closest('[data-fm-catalogue-variant-picker]');
        const scope = variantOption.closest('.' + root.id + '__product, .' + root.id + '__drawer-product');

        if (picker && scope) {
          const variantId = variantOption.getAttribute('data-variant-id');
          const price = variantOption.getAttribute('data-variant-price');
          const priceCents = variantOption.getAttribute('data-variant-price-cents');
          const title = variantOption.getAttribute('data-variant-title');

          picker.querySelectorAll('[data-fm-catalogue-variant-option]').forEach(function (option) {
            const isActive = option === variantOption;
            option.classList.toggle('is-active', isActive);
            option.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          const priceEl = scope.querySelector('.' + root.id + '__price-value');
          if (priceEl && price) priceEl.textContent = price;

          const metaEl = scope.querySelector('.' + root.id + '__product-meta, .' + root.id + '__drawer-meta span');
          if (metaEl && title) metaEl.textContent = title;

          const addBtn = scope.querySelector('[data-fm-catalogue-add]');
          if (addBtn && variantId) addBtn.setAttribute('data-fm-catalogue-add', variantId);

          const qtyControl = scope.querySelector('[data-fm-catalogue-qty-control]');
          if (qtyControl && variantId) {
            qtyControl.setAttribute('data-variant-id', variantId);
            if (priceCents) qtyControl.setAttribute('data-unit-price', priceCents);
            if (window.FMCart && typeof window.FMCart.fetchCart === 'function') {
              window.FMCart.fetchCart().then(function (cartData) {
                syncQuantityControls(variantId, cartData);
              }).catch(function () {});
            }
          }
        }
        return;
      }

      const opener = event.target.closest('[data-fm-catalogue-open]');
      if (opener && root.contains(opener)) {
        event.preventDefault();
        openProduct(opener.getAttribute('data-fm-catalogue-open'));
        return;
      }

      const quickAdd = event.target.closest('[data-fm-catalogue-add]');
      if (quickAdd && root.contains(quickAdd)) {
        event.preventDefault();
        event.stopPropagation();
        const variantId = quickAdd.getAttribute('data-fm-catalogue-add');
        if (!variantId || !window.FMCart || typeof window.FMCart.addVariant !== 'function') return;

        const quickScope = quickAdd.closest('[data-fm-catalogue-product], [class$="__drawer-product"]');
        const quickControl = quickScope ? quickScope.querySelector('[data-fm-catalogue-qty-control]') : null;
        if (quickControl) {
          handleQuantityControl(quickControl, 1, quickAdd);
        } else {
          const quickUnitPrice = Math.max(Number(quickAdd.getAttribute('data-unit-price')) || 0, 0);
          const hasOptimisticHeader = typeof window.FMCart.beginOptimisticHeaderUpdate === 'function'
            && typeof window.FMCart.settleOptimisticHeaderUpdate === 'function';
          renderQuantityControls(variantId, currentQuantityForVariant(variantId) + 1);
          if (hasOptimisticHeader) window.FMCart.beginOptimisticHeaderUpdate(quickUnitPrice, 1);
          window.FMCart.addVariant(variantId, { button: quickAdd, quantity: 1, openDrawer: false })
            .then(function (cartData) {
              syncQuantityControls(variantId, cartData);
            })
            .catch(function (error) {
              console.error(error);
              if (typeof window.FMCart.fetchCart === 'function') {
                window.FMCart.fetchCart().then(function (cartData) {
                  syncQuantityControls(variantId, cartData);
                }).catch(function () {});
              }
            })
            .finally(function () {
              if (hasOptimisticHeader) window.FMCart.settleOptimisticHeaderUpdate();
            });
        }
        return;
      }

      const productCard = event.target.closest('[data-fm-catalogue-product-detail]');
      if (productCard && root.contains(productCard) && !event.target.closest('button, a, input, select, textarea')) {
        event.preventDefault();
        openProduct(productCard.getAttribute('data-fm-catalogue-product-detail'));
        return;
      }

      const hero = event.target.closest('[data-fm-catalogue-hero-link]');
      if (hero && root.contains(hero) && !event.target.closest('a, button')) {
        const href = hero.getAttribute('data-fm-catalogue-hero-link');
        if (href) window.location.href = href;
        return;
      }

      const prev = event.target.closest('[data-fm-catalogue-prev]');
      const next = event.target.closest('[data-fm-catalogue-next]');

      if ((prev || next) && root.contains(prev || next)) {
        const rail = (prev || next).closest('[data-fm-catalogue-rail]');
        const track = rail ? rail.querySelector('[data-fm-catalogue-track]') : null;
        if (track) {
          const direction = next ? 1 : -1;
          track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.82, 260), behavior: 'smooth' });
        }
        return;
      }

      const jump = event.target.closest('[data-fm-catalogue-jump]');
      if (jump && root.contains(jump)) {
        event.preventDefault();

        root.querySelectorAll('.is-active').forEach(function (item) {
          if (item.matches('a, button')) item.classList.remove('is-active');
        });
        jump.classList.add('is-active');
        const jumpRailId = jump.getAttribute('data-fm-catalogue-jump');
        showSingleRail(jumpRailId);
        const jumpRail = document.getElementById(jumpRailId);
        setCatalogueViewUrl(jumpRail ? jumpRail.getAttribute('data-fm-catalogue-category-handle') : '', '', false);
        setMobileNavigation(false);
        return;
      }

      const subToggle = event.target.closest('[data-fm-catalogue-subtoggle]');
      if (subToggle && root.contains(subToggle)) {
        event.preventDefault();

        const group = subToggle.closest('[data-fm-catalogue-side-group]');
        const isOpen = group && group.classList.contains('is-open');
        const targetId = subToggle.getAttribute('data-fm-catalogue-target');

        if (isOpen) {
          group.classList.remove('is-open');
          subToggle.setAttribute('aria-expanded', 'false');
          subToggle.classList.remove('is-active');
          return;
        }

        root.querySelectorAll('[data-fm-catalogue-side-group]').forEach(function (item) {
          const button = item.querySelector('[data-fm-catalogue-subtoggle]');
          const open = item === group;
          item.classList.toggle('is-open', open);
          if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        root.querySelectorAll('.is-active').forEach(function (item) {
          if (item.matches('a, button')) item.classList.remove('is-active');
        });
        subToggle.classList.add('is-active');

        if (!isDesktopCatalogue()) return;

        showSingleRail(targetId);
        const targetRail = document.getElementById(targetId);
        setCatalogueViewUrl(targetRail ? targetRail.getAttribute('data-fm-catalogue-category-handle') : '', '', false);
      }
    });

    if (search) {
      search.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        /* un seul caractere : trop tot pour une recherche reseau (la touche
           Entree ou le bouton restent possibles a tout moment) */
        if (search.value.trim().length === 1) return;
        searchTimer = window.setTimeout(function () {
          searchAllProducts(search.value);
        }, 240);
      });

      const searchForm = search.closest('form');
      if (searchForm) {
        searchForm.addEventListener('submit', function (event) {
          event.preventDefault();
          window.clearTimeout(searchTimer);
          searchAllProducts(search.value);
        });
      }
    }

    root.addEventListener('submit', handleCatalogueCartSubmit, true);
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const opener = event.target.closest('[data-fm-catalogue-open]');
      if (!opener || !root.contains(opener)) return;

      event.preventDefault();
      openProduct(opener.getAttribute('data-fm-catalogue-open'));
    });

    if (window.FMCart && typeof window.FMCart.fetchCart === 'function') {
      window.FMCart.fetchCart().then(function (cartData) {
        root.querySelectorAll('[data-fm-catalogue-qty-control][data-variant-id]').forEach(function (control) {
          syncQuantityControls(control.getAttribute('data-variant-id'), cartData);
        });
      }).catch(function () {});
    }

    root.querySelectorAll('[data-fm-catalogue-hero-link]').forEach(function (hero) {
      hero.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const href = hero.getAttribute('data-fm-catalogue-hero-link');
        if (!href) return;

        event.preventDefault();
        window.location.href = href;
      });
    });

    if (drawer) {
      drawer.addEventListener('click', function (event) {
        if (event.target === drawer) closeProduct();
      });
    }

    if (authGateModal) {
      authGateModal.addEventListener('click', function (event) {
        if (event.target === authGateModal) setAuthGate(false);
      });
    }

    if (authGateClose) authGateClose.addEventListener('click', function () { setAuthGate(false); });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeProduct);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        closeProduct();
      }
      if (event.key === 'Escape' && authGateModal && authGateModal.classList.contains('is-open')) {
        setAuthGate(false);
      }
      if (event.key === 'Escape' && root.classList.contains('is-mobile-nav-open')) {
        setMobileNavigation(false);
      }
    });

    const listQueries = getListQueriesFromUrl();
    const initialParams = new URLSearchParams(window.location.search || '');
    const initialProductHandle = initialParams.get('product') || '';

    if (initialParams.get('cart') === 'open') {
      window.setTimeout(function () {
        if (window.FMCart && typeof window.FMCart.openCart === 'function') {
          window.FMCart.openCart();
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('cart');
          window.history.replaceState(window.history.state, '', cleanUrl.pathname + cleanUrl.search);
        }
      }, 120);
    }

    if (initialProductHandle) {
      showHomeRails();
      openProductFromHandle(initialProductHandle);
    } else if (listQueries.length === 1) {
      if (search) search.value = listQueries[0];
      searchAllProducts(listQueries[0]);
    } else if (listQueries.length && renderListResults(listQueries)) {
    } else if (restoreCatalogueViewFromUrl()) {
    } else if (window.location.hash) {
      const hashTarget = window.location.hash.slice(1);
      const hashRail = document.getElementById(hashTarget);

      if (hashRail && hashRail.hasAttribute('data-fm-catalogue-rail')) {
        window.setTimeout(function () {
          showSingleRail(hashTarget);
        }, 80);
      } else {
        showHomeRails();
      }
    } else {
      showHomeRails();
    }

    window.addEventListener('popstate', function () {
      if (!restoreCatalogueViewFromUrl()) showHomeRails();
    });

    updateViewportHeight();
    containWheel(mainScroller);
    containWheel(sideScroller);

    window.addEventListener('resize', updateViewportHeight);
    window.addEventListener('orientationchange', updateViewportHeight);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateViewportHeight);
    }

    root.dataset.fmCatalogueReady = 'true';
  }

  function initAllCatalogues(scope) {
    (scope || document).querySelectorAll('[data-fm-catalogue]').forEach(initCatalogue);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllCatalogues(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllCatalogues(event.target);
  });
})();

(function () {
  function initFmHeader(root) {
    const scope = root || document;
    const headers = scope.querySelectorAll('[data-fm-header]:not([data-fm-header-ready])');

    headers.forEach((header) => {
      header.setAttribute('data-fm-header-ready', 'true');

      const searchInput = header.querySelector('[data-fm-header-search-input]');
      const searchPanel = header.querySelector('[data-fm-header-search-panel]');
      const backdrop = header.querySelector('[data-fm-header-backdrop]');
      const modal = header.querySelector('[data-fm-header-modal]');
      const mobilePanel = header.querySelector('[data-fm-header-mobile-panel]');
      const openSearchButtons = header.querySelectorAll('[data-fm-header-open-search]');
      const openModalButtons = header.querySelectorAll('[data-fm-header-open-modal]');
      const closeButtons = header.querySelectorAll('[data-fm-header-close]');
      const toggleMenuButton = header.querySelector('[data-fm-header-toggle-menu]');
      const suggestionButtons = header.querySelectorAll('[data-fm-header-suggestion]');
      const listSubmit = header.querySelector('[data-fm-list-submit]');
      let transparentHeaderThreshold = 18;
      let menuReturnFocus = null;

      function updateTransparentHeaderThreshold() {
        if (header.getAttribute('data-transparent') !== 'true') return;

        const hero = document.querySelector('#MainContent .fm-hero-v3--background');
        if (!hero) return;

        transparentHeaderThreshold = Math.max(
          18,
          hero.getBoundingClientRect().top + window.scrollY + hero.offsetHeight - header.offsetHeight
        );
      }

      function updateScrollState() {
        if (window.scrollY > transparentHeaderThreshold) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
      }

      function showBackdrop() {
        if (backdrop) backdrop.hidden = false;
      }

      function hideBackdrop() {
        if (backdrop) backdrop.hidden = true;
      }

      function updateSearchPanelPosition() {
        if (!searchPanel || !searchInput) return;

        const searchForm = searchInput.closest('.fm-header__search');
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;

        if (!searchForm || !isDesktop) {
          searchPanel.style.removeProperty('--fm-search-panel-left');
          searchPanel.style.removeProperty('--fm-search-panel-top');
          searchPanel.style.removeProperty('--fm-search-panel-width');
          searchPanel.style.removeProperty('--fm-search-panel-shift');
          return;
        }

        const searchRect = searchForm.getBoundingClientRect();
        const headerRect = header.getBoundingClientRect();
        const gutter = 20;
        const panelWidth = Math.min(760, window.innerWidth - (gutter * 2));
        const preferredLeft = searchRect.left;
        const panelLeft = Math.max(gutter, Math.min(preferredLeft, window.innerWidth - panelWidth - gutter));

        searchPanel.style.setProperty('--fm-search-panel-left', Math.round(panelLeft) + 'px');
        searchPanel.style.setProperty('--fm-search-panel-top', Math.round(headerRect.bottom + 8) + 'px');
        searchPanel.style.setProperty('--fm-search-panel-width', Math.round(panelWidth) + 'px');
        searchPanel.style.setProperty('--fm-search-panel-shift', '0px');
        header.style.setProperty('--fm-header-open-height', Math.round(headerRect.bottom) + 'px');
      }

      function openSearch() {
        if (!searchPanel) return;
        updateSearchPanelPosition();
        header.classList.add('is-search-open');
        searchPanel.hidden = false;
        showBackdrop();
        if (searchInput) searchInput.setAttribute('aria-expanded', 'true');

        if (searchInput) {
          window.setTimeout(() => searchInput.focus(), 30);
        }
      }

      function closeSearch() {
        header.classList.remove('is-search-open');
        if (searchPanel) searchPanel.hidden = true;
        if (searchInput) searchInput.setAttribute('aria-expanded', 'false');

        if (!header.classList.contains('is-modal-open') && !header.classList.contains('is-menu-open')) {
          hideBackdrop();
        }
      }

      function openModal() {
        header.classList.add('is-modal-open');
        closeSearch();
        if (modal) modal.hidden = false;
        showBackdrop();

        const firstField = modal ? modal.querySelector('input, textarea, button') : null;
        if (firstField) {
          window.setTimeout(() => firstField.focus(), 30);
        }
      }

      function closeModal() {
        header.classList.remove('is-modal-open');
        if (modal) modal.hidden = true;

        if (!header.classList.contains('is-search-open') && !header.classList.contains('is-menu-open')) {
          hideBackdrop();
        }
      }

      function openMenu() {
        menuReturnFocus =
          document.activeElement && document.activeElement !== document.body
            ? document.activeElement
            : toggleMenuButton;
        header.classList.add('is-menu-open');
        if (mobilePanel) mobilePanel.hidden = false;
        if (toggleMenuButton) toggleMenuButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('fm-menu-lock');
        document.body.classList.add('fm-menu-lock');
        showBackdrop();

        const closeMenuButton = mobilePanel ? mobilePanel.querySelector('[data-fm-header-close]') : null;
        if (closeMenuButton) {
          window.setTimeout(() => closeMenuButton.focus(), 80);
        }
      }

      function closeMenu() {
        const wasOpen = header.classList.contains('is-menu-open');
        const focusTarget = menuReturnFocus;
        header.classList.remove('is-menu-open');
        if (mobilePanel) mobilePanel.hidden = true;
        if (toggleMenuButton) toggleMenuButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('fm-menu-lock');
        document.body.classList.remove('fm-menu-lock');

        if (!header.classList.contains('is-search-open') && !header.classList.contains('is-modal-open')) {
          hideBackdrop();
        }

        if (wasOpen && focusTarget && typeof focusTarget.focus === 'function') {
          window.setTimeout(() => focusTarget.focus(), 20);
        }

        menuReturnFocus = null;
      }

      function closeAll() {
        closeSearch();
        closeModal();
        closeMenu();
        hideBackdrop();
      }

      function parseSupplyList(value) {
        return String(value || '')
          .split(/[\n,;]+/)
          .map(function (term) {
            return term
              .replace(/^[\s\-•*]+/, '')
              .replace(/\s+/g, ' ')
              .trim();
          })
          .filter(function (term, index, source) {
            const normalized = term.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            return normalized && source.findIndex(function (candidate) {
              return candidate.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === normalized;
            }) === index;
          })
          .slice(0, 8);
      }

      function buildCatalogueListUrl(terms) {
        const params = new URLSearchParams();

        terms.forEach(function (term, index) {
          params.set('q' + index, term);
        });

        return '/pages/catalogue' + (params.toString() ? '?' + params.toString() : '');
      }

      updateTransparentHeaderThreshold();
      updateScrollState();
      window.addEventListener('scroll', updateScrollState, { passive: true });
      window.addEventListener('resize', function () {
        updateTransparentHeaderThreshold();
        updateScrollState();
        if (header.classList.contains('is-search-open')) updateSearchPanelPosition();
      });

      if (searchInput) {
        searchInput.addEventListener('focus', openSearch);
        searchInput.addEventListener('click', openSearch);
        searchInput.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowDown' || !suggestionButtons.length) return;

          event.preventDefault();
          suggestionButtons[0].focus();
        });
      }

      openSearchButtons.forEach((button) => {
        button.addEventListener('click', openSearch);
      });

      openModalButtons.forEach((button) => {
        button.addEventListener('click', openModal);
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', closeAll);
      });

      if (toggleMenuButton) {
        toggleMenuButton.addEventListener('click', () => {
          if (header.classList.contains('is-menu-open')) {
            closeMenu();
          } else {
            closeSearch();
            closeModal();
            openMenu();
          }
        });
      }

      suggestionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.getAttribute('data-fm-header-suggestion');

          if (searchInput && value) {
            searchInput.value = value;
            // une suggestion cliquée doit CHERCHER, pas seulement remplir le champ
            if (searchInput.form) {
              searchInput.form.submit();
            } else {
              window.location.href = '/pages/catalogue?q0=' + encodeURIComponent(value);
            }
          }
        });

        button.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

          event.preventDefault();
          const buttons = Array.from(suggestionButtons);
          const currentIndex = buttons.indexOf(button);

          if (event.key === 'ArrowDown') {
            buttons[(currentIndex + 1) % buttons.length].focus();
          } else if (currentIndex === 0 && searchInput) {
            searchInput.focus();
          } else {
            buttons[currentIndex - 1].focus();
          }
        });
      });

      if (listSubmit) {
        listSubmit.addEventListener('click', function (event) {
          const textarea = modal ? modal.querySelector('[name="fm_supply_list"]') : null;
          const terms = parseSupplyList(textarea ? textarea.value : '');

          if (!terms.length) return;

          event.preventDefault();
          window.location.href = buildCatalogueListUrl(terms);
        });
      }

      if (backdrop) {
        backdrop.addEventListener('click', closeAll);
      }

      document.addEventListener('click', (event) => {
        if (!header.classList.contains('is-search-open')) return;

        const clickedSearchInput = searchInput && (event.target === searchInput || event.target.closest('.fm-header__search'));
        const clickedSearchPanel = searchPanel && searchPanel.contains(event.target);
        const clickedSearchButton = event.target.closest('[data-fm-header-open-search]');
        const clickedModalButton = event.target.closest('[data-fm-header-open-modal]');

        if (clickedSearchInput || clickedSearchPanel || clickedSearchButton || clickedModalButton) return;

        closeSearch();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Tab' && header.classList.contains('is-menu-open') && mobilePanel) {
          const focusableElements = Array.from(
            mobilePanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
          ).filter((element) => !element.hidden && element.offsetParent !== null);

          if (focusableElements.length) {
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (event.shiftKey && document.activeElement === firstElement) {
              event.preventDefault();
              lastElement.focus();
            } else if (!event.shiftKey && document.activeElement === lastElement) {
              event.preventDefault();
              firstElement.focus();
            }
          }
        }

        if (event.key === 'Escape') {
          closeAll();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initFmHeader(document));

  document.addEventListener('shopify:section:load', (event) => {
    initFmHeader(event.target);
  });
})();

document.addEventListener('click', function (event) {
  const closeButton = event.target.closest('[data-fm-header-close]');
  const backdrop = event.target.closest('[data-fm-header-backdrop]');

  if (!closeButton && !backdrop) return;

  const header = event.target.closest('[data-fm-header]') || document.querySelector('[data-fm-header]');
  if (!header) return;

  const modal = header.querySelector('[data-fm-header-modal]');
  const searchPanel = header.querySelector('[data-fm-header-search-panel]');
  const mobilePanel = header.querySelector('[data-fm-header-mobile-panel]');
  const backdropEl = header.querySelector('[data-fm-header-backdrop]');

  header.classList.remove('is-modal-open', 'is-search-open', 'is-menu-open');

  if (modal) modal.hidden = true;
  if (searchPanel) searchPanel.hidden = true;
  if (mobilePanel) mobilePanel.hidden = true;
  if (backdropEl) backdropEl.hidden = true;
});

/* ==========================================================================
   FIX FINAL - Header popup open / close
   ========================================================================== */

(function () {
  function getHeaderFromElement(element) {
    return element.closest('[data-fm-header]') || document.querySelector('[data-fm-header]');
  }

  function closeFmPopup(header) {
    if (!header) return;

    const modal = header.querySelector('[data-fm-header-modal]');
    const backdrop = header.querySelector('[data-fm-header-backdrop]');
    const searchPanel = header.querySelector('[data-fm-header-search-panel]');
    const mobilePanel = header.querySelector('[data-fm-header-mobile-panel]');
    const burger = header.querySelector('[data-fm-header-toggle-menu]');

    header.classList.remove('is-modal-open', 'is-search-open', 'is-menu-open');

    if (modal) modal.hidden = true;
    if (backdrop) backdrop.hidden = true;
    if (searchPanel) searchPanel.hidden = true;
    if (mobilePanel) mobilePanel.hidden = true;
    if (burger) burger.setAttribute('aria-expanded', 'false');

    document.documentElement.classList.remove('fm-popup-lock');
    document.body.classList.remove('fm-popup-lock');
  }

  function openFmPopup(header) {
    if (!header) return;

    const modal = header.querySelector('[data-fm-header-modal]');
    const backdrop = header.querySelector('[data-fm-header-backdrop]');
    const searchPanel = header.querySelector('[data-fm-header-search-panel]');
    const mobilePanel = header.querySelector('[data-fm-header-mobile-panel]');

    if (!modal) return;

    header.classList.add('is-modal-open');
    header.classList.remove('is-search-open', 'is-menu-open');

    if (searchPanel) searchPanel.hidden = true;
    if (mobilePanel) mobilePanel.hidden = true;
    if (backdrop) backdrop.hidden = false;

    modal.hidden = false;

    document.documentElement.classList.add('fm-popup-lock');
    document.body.classList.add('fm-popup-lock');

    const firstField = modal.querySelector('textarea, input, button');
    if (firstField) {
      window.setTimeout(function () {
        firstField.focus();
      }, 40);
    }
  }

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-fm-header-open-modal]');
    const closeButton = event.target.closest('[data-fm-header-close]');
    const backdrop = event.target.closest('[data-fm-header-backdrop]');
    const modal = event.target.closest('[data-fm-header-modal]');
    const modalCard = event.target.closest('.fm-header__modal-card');

    if (openButton) {
      event.preventDefault();
      openFmPopup(getHeaderFromElement(openButton));
      return;
    }

    if (closeButton) {
      event.preventDefault();
      closeFmPopup(getHeaderFromElement(closeButton));
      return;
    }

    if (backdrop) {
      event.preventDefault();
      closeFmPopup(getHeaderFromElement(backdrop));
      return;
    }

    if (modal && !modalCard) {
      event.preventDefault();
      closeFmPopup(getHeaderFromElement(modal));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const openedHeader = document.querySelector('[data-fm-header].is-modal-open');
    if (openedHeader) {
      closeFmPopup(openedHeader);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-fm-header]').forEach(function (header) {
      const modal = header.querySelector('[data-fm-header-modal]');
      const backdrop = header.querySelector('[data-fm-header-backdrop]');

      if (modal && !header.classList.contains('is-modal-open')) {
        modal.hidden = true;
      }

      if (backdrop && !header.classList.contains('is-modal-open') && !header.classList.contains('is-search-open')) {
        backdrop.hidden = true;
      }
    });
  });
})();

document.addEventListener('click', function (event) {
  const closeButton = event.target.closest('[data-fm-header-close]');
  const backdrop = event.target.closest('[data-fm-header-backdrop]');
  const modalOverlay = event.target.matches('[data-fm-header-modal]');

  if (!closeButton && !backdrop && !modalOverlay) return;

  event.preventDefault();

  const header =
    event.target.closest('[data-fm-header]') ||
    document.querySelector('[data-fm-header]');

  if (!header) return;

  const modal = header.querySelector('[data-fm-header-modal]');
  const backdropEl = header.querySelector('[data-fm-header-backdrop]');
  const searchPanel = header.querySelector('[data-fm-header-search-panel]');
  const mobilePanel = header.querySelector('[data-fm-header-mobile-panel]');

  header.classList.remove('is-modal-open', 'is-search-open', 'is-menu-open');

  if (modal) modal.hidden = true;
  if (backdropEl) backdropEl.hidden = true;
  if (searchPanel) searchPanel.hidden = true;
  if (mobilePanel) mobilePanel.hidden = true;

  document.documentElement.classList.remove('fm-popup-lock');
  document.body.classList.remove('fm-popup-lock');
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  const header = document.querySelector('[data-fm-header].is-modal-open');
  if (!header) return;

  const modal = header.querySelector('[data-fm-header-modal]');
  const backdropEl = header.querySelector('[data-fm-header-backdrop]');

  header.classList.remove('is-modal-open');

  if (modal) modal.hidden = true;
  if (backdropEl) backdropEl.hidden = true;

  document.documentElement.classList.remove('fm-popup-lock');
  document.body.classList.remove('fm-popup-lock');
});

/* ==========================================================================
   Frescomarché - Account routes guard
   ========================================================================== */

(function () {
  /* jamais de redirection dans l'editeur de theme : l'apercu des templates
     compte deviendrait impossible a configurer */
  if (window.Shopify && window.Shopify.designMode) return;

  var dashboardPath = '/pages/mon-compte-pro';
  var legacyDashboardPath = '/pages/espace-pro';
  var loginPath = '/pages/connexion';

  function normalizePath(path) {
    return String(path || '').replace(/\/+$/, '') || '/';
  }

  function parseUrl(href) {
    try {
      return new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function isNativeAccountUrl(url) {
    if (!url) return false;

    var path = normalizePath(url.pathname);
    var host = url.hostname;
    var isShopifyAuthHost = host === 'shopify.com' || host.endsWith('.shopify.com');

    if (path.indexOf('/account/logout') === 0 || path.indexOf('/105876193605/account/logout') !== -1) {
      return false;
    }

    // Les pages de commande (détail, facture) restent accessibles :
    // seul l'accueil du compte natif est rabattu vers le dashboard pro.
    if (path.indexOf('/account/orders') !== -1 || path.indexOf('/orders/') !== -1) {
      return false;
    }

    // La gestion d'adresses native reste accessible : l'espace pro y renvoie
    // explicitement (« Gérer mes adresses »).
    if (path.indexOf('/account/addresses') === 0) {
      return false;
    }

    // Les liens des emails transactionnels doivent atteindre leurs formulaires
    // natifs : activation d'invitation (aboutissement du funnel pro) et
    // reinitialisation de mot de passe.
    if (path.indexOf('/account/activate') === 0 || path.indexOf('/account/reset') === 0) {
      return false;
    }

    return path === '/account' ||
      path.indexOf('/account/') === 0 ||
      path.indexOf('/105876193605/account') !== -1 ||
      (isShopifyAuthHost && (
        path.indexOf('/account') !== -1 ||
        path.indexOf('/105876193605/account') !== -1
      ));
  }

  function isLegacyDashboardUrl(url) {
    if (!url) return false;
    return normalizePath(url.pathname) === legacyDashboardPath;
  }

  /* /account/register et /account/login ne doivent PAS etre rabattus vers le
     dashboard (un visiteur qui clique « Creer mon compte pro » atterrissait
     sur l'espace client !) : ils ont leurs pages de marque dediees. */
  function nativeAuthTarget(url) {
    if (!url) return null;
    var path = normalizePath(url.pathname);
    if (path.indexOf('/account/register') === 0) return '/pages/inscription-pro';
    if (path.indexOf('/account/login') === 0) return loginPath;
    return null;
  }

  function redirectToDashboard() {
    window.location.replace(dashboardPath);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var url = parseUrl(link.getAttribute('href'));
    if (!url) return;

    var authTarget = nativeAuthTarget(url);
    if (authTarget) {
      event.preventDefault();
      window.location.href = authTarget;
      return;
    }

    if (isNativeAccountUrl(url) || isLegacyDashboardUrl(url)) {
      event.preventDefault();
      window.location.href = dashboardPath;
      return;
    }

    if (url.pathname === '/customer_authentication/login' && url.search.indexOf('%2Fpages%2Fespace-pro') !== -1) {
      event.preventDefault();
      window.location.href = loginPath;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var currentUrl = parseUrl(window.location.href);
    var authTarget = nativeAuthTarget(currentUrl);
    if (authTarget) {
      window.location.replace(authTarget);
      return;
    }
    if (isNativeAccountUrl(currentUrl) || isLegacyDashboardUrl(currentUrl)) {
      redirectToDashboard();
    }
  });
})();

/* ==========================================================================
   Frescomarché - Stats & Contact CTA
   ========================================================================== */

(function () {
  function getFocusableElements(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function initStatsContact(root) {
    if (!root || root.dataset.fmStatsContactInitialized === 'true') {
      return;
    }

    var modal = root.querySelector('[data-fm-stats-contact-modal]');
    if (!modal) {
      root.dataset.fmStatsContactInitialized = 'true';
      return;
    }

    var dialog = modal.querySelector('.fm-stats-contact-modal__dialog');
    var openers = root.querySelectorAll('[data-fm-stats-contact-open]');
    var previousActiveElement = null;

    function openModal() {
      previousActiveElement = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      openers.forEach(function (opener) {
        opener.setAttribute('aria-expanded', 'true');
      });
      document.body.classList.add('fm-stats-contact-modal-open');

      window.requestAnimationFrame(function () {
        var focusable = getFocusableElements(dialog);
        var target = focusable[0] || dialog;
        target.focus({ preventScroll: true });
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      openers.forEach(function (opener) {
        opener.setAttribute('aria-expanded', 'false');
      });

      if (!document.querySelector('.fm-stats-contact-modal.is-open')) {
        document.body.classList.remove('fm-stats-contact-modal-open');
      }

      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus({ preventScroll: true });
      }
    }

    function handleKeydown(event) {
      if (!modal.classList.contains('is-open')) {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      var focusable = getFocusableElements(dialog);
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function handleRootClick(event) {
      var opener = event.target.closest('[data-fm-stats-contact-open]');
      if (opener && root.contains(opener)) {
        event.preventDefault();
        openModal();
        return;
      }

      var closer = event.target.closest('[data-fm-stats-contact-close]');
      if (closer && root.contains(closer)) {
        event.preventDefault();
        closeModal();
      }
    }

    root.addEventListener('click', handleRootClick);
    document.addEventListener('keydown', handleKeydown);

    if (modal.querySelector('.fm-stats-contact-modal__success, .fm-stats-contact-modal__errors')) {
      window.requestAnimationFrame(openModal);
    }

    root.fmStatsContactCleanup = function () {
      root.removeEventListener('click', handleRootClick);
      document.removeEventListener('keydown', handleKeydown);
      if (modal.classList.contains('is-open')) {
        closeModal();
      }
      delete root.fmStatsContactCleanup;
      delete root.dataset.fmStatsContactInitialized;
    };
    root.dataset.fmStatsContactInitialized = 'true';
  }

  function initAllStatsContact(scope) {
    var container = scope || document;
    container.querySelectorAll('.fm-stats-contact').forEach(initStatsContact);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllStatsContact(document);

    /* Purge une éventuelle propriété créée par l’ancienne version dès l’ouverture du catalogue. */
    if (document.querySelector('[data-fm-catalogue]') && typeof window.fmClearCheckoutDeliveryLineProperties === 'function') {
      window.fmClearCheckoutDeliveryLineProperties();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllStatsContact(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('.fm-stats-contact')
      ? event.target
      : event.target.querySelector('.fm-stats-contact');

    if (root && typeof root.fmStatsContactCleanup === 'function') {
      root.fmStatsContactCleanup();
    }
  });
})();

/* ==========================================================================
   Frescomarché - Préférences persistantes (note, facturation)
   Shopify détruit le panier au checkout : on ré-applique note et attributs
   depuis le localStorage sur le nouveau panier, sur toutes les pages.
   ========================================================================== */

(function () {
  var applying = false;

  function reapplyPrefs() {
    if (applying) return;
    var note = '', billing = null, contacts = null, legacyMail = '';
    try {
      note = localStorage.getItem('fm_delivery_note') || '';
      billing = JSON.parse(localStorage.getItem('fm_billing') || 'null');
      contacts = JSON.parse(localStorage.getItem('fm_invoice_contacts') || 'null');
      legacyMail = localStorage.getItem('fm_invoice_email') || '';
    } catch (error) { return; }
    var emails = contacts
      ? contacts.filter(function (c) { return c && c.on; }).map(function (c) { return c.e; }).join(', ')
      : legacyMail;
    var addr = billing
      ? [billing.company, billing.street, ((billing.zip || '') + ' ' + (billing.city || '')).trim()].filter(Boolean).join(', ')
      : '';
    var mode = billing && billing.mode
      ? (billing.mode === 'quinzaine' ? 'Groupée tous les 15 jours' : 'À chaque commande')
      : '';
    if (!note && !emails && !addr) return;
    applying = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var current = cart.attributes || {};
        var body = {};
        var attrs = {};
        if (note && !cart.note) body.note = note;
        if (addr && !current['Adresse de facturation']) attrs['Adresse de facturation'] = addr;
        if (emails && !current['Email facturation']) attrs['Email facturation'] = emails;
        if (mode && !current['Mode de facturation']) attrs['Mode de facturation'] = mode;
        if (Object.keys(attrs).length) body.attributes = attrs;
        if (!Object.keys(body).length) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .catch(function () {})
      .then(function () { applying = false; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reapplyPrefs);
  } else {
    reapplyPrefs();
  }
  document.addEventListener('fm:cart:added', function () { setTimeout(reapplyPrefs, 400); });
})();
